"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/generatedTypes/graphql.ts
var graphql_exports = {};
__export(graphql_exports, {
  AcceptInvitationDocument: () => AcceptInvitationDocument,
  ActivationStatus: () => ActivationStatus,
  AddressType: () => AddressType,
  AdmissionPer: () => AdmissionPer,
  AffiliateProgramme: () => AffiliateProgramme,
  AmendmentStatus: () => AmendmentStatus,
  BookingFlowType: () => BookingFlowType,
  BookingStatus: () => BookingStatus,
  BookingType: () => BookingType,
  BulkImportTranslationMemoryClassification: () => BulkImportTranslationMemoryClassification,
  BusinessUnit: () => BusinessUnit,
  Businessunit: () => Businessunit,
  CalculationStatus: () => CalculationStatus,
  CancelBookingDocument: () => CancelBookingDocument,
  CancelPaymentSessionDocument: () => CancelPaymentSessionDocument,
  CatalogueDataOrigin: () => CatalogueDataOrigin,
  CatalogueLocale: () => CatalogueLocale,
  CatalogueLocationType: () => CatalogueLocationType,
  CatalogueProductType: () => CatalogueProductType,
  CatalogueProgramme: () => CatalogueProgramme,
  ChangeReason: () => ChangeReason,
  ChargeOwner: () => ChargeOwner,
  ChatbotParticipantRole: () => ChatbotParticipantRole,
  CheckinBookingDocument: () => CheckinBookingDocument,
  ConfirmAmendmentDocument: () => ConfirmAmendmentDocument,
  ConfirmBookingDocument: () => ConfirmBookingDocument,
  ConfirmPaymentDocument: () => ConfirmPaymentDocument,
  ConsumerCostZone: () => ConsumerCostZone,
  ConsumerLocationType: () => ConsumerLocationType,
  ConsumerOutletRegion: () => ConsumerOutletRegion,
  ConsumerPassengerType: () => ConsumerPassengerType,
  ConsumerPrimaryProductAccessType: () => ConsumerPrimaryProductAccessType,
  ConsumerProductCategory: () => ConsumerProductCategory,
  ConsumerProgramme: () => ConsumerProgramme,
  ConsumerTier: () => ConsumerTier,
  CostZone: () => CostZone,
  CreateBookingDocument: () => CreateBookingDocument,
  CreateTranslationMemoryItemDocument: () => CreateTranslationMemoryItemDocument,
  Currency: () => Currency,
  DealIneligibilityReason: () => DealIneligibilityReason,
  DeclineBookingDocument: () => DeclineBookingDocument,
  DeleteBookingDocument: () => DeleteBookingDocument,
  EnrollmentStatus: () => EnrollmentStatus,
  EntitlementIsoCountryCode: () => EntitlementIsoCountryCode,
  EntitlementLevel: () => EntitlementLevel,
  EntitlementLocationType: () => EntitlementLocationType,
  EntitlementOutletRegion: () => EntitlementOutletRegion,
  EntitlementPassengerType: () => EntitlementPassengerType,
  EntitlementProductAccessType: () => EntitlementProductAccessType,
  EntitlementProductCategory: () => EntitlementProductCategory,
  EntitlementProgramme: () => EntitlementProgramme,
  EntitlementSelectionMode: () => EntitlementSelectionMode,
  EntitlementStatus: () => EntitlementStatus,
  ExceptionType: () => ExceptionType,
  ExperienceCategory: () => ExperienceCategory,
  ExperienceType: () => ExperienceType,
  FakeDoorInterest: () => FakeDoorInterest,
  FakeDoorOs: () => FakeDoorOs,
  FakeDoorType: () => FakeDoorType,
  FavouriteEntityType: () => FavouriteEntityType,
  FindOrCreateConsumerDocument: () => FindOrCreateConsumerDocument,
  ForecastDocument: () => ForecastDocument,
  GetAvailableSlotsDocument: () => GetAvailableSlotsDocument,
  GetBookingByIdDocument: () => GetBookingByIdDocument,
  GetBookingsDocument: () => GetBookingsDocument,
  GetBookingsOverviewDocument: () => GetBookingsOverviewDocument,
  GetConsumerByEmailAddressDocument: () => GetConsumerByEmailAddressDocument,
  GetConsumerByIdDocument: () => GetConsumerByIdDocument,
  GetConsumerDocument: () => GetConsumerDocument,
  GetEntitlementsForProductDocument: () => GetEntitlementsForProductDocument,
  GetExperienceByIdDocument: () => GetExperienceByIdDocument,
  GetFlightDetailsDocument: () => GetFlightDetailsDocument,
  GetInvitationByIdDocument: () => GetInvitationByIdDocument,
  GetLocationDescriptionDocument: () => GetLocationDescriptionDocument,
  GetMeDocument: () => GetMeDocument,
  GetOutletDocument: () => GetOutletDocument,
  GetOutletLocationDetailsGroupsDocument: () => GetOutletLocationDetailsGroupsDocument,
  GetOutletsCountDocument: () => GetOutletsCountDocument,
  GetOutletsDocument: () => GetOutletsDocument,
  GetPartnerBrandByIdDocument: () => GetPartnerBrandByIdDocument,
  GetPartnerBrandsCountDocument: () => GetPartnerBrandsCountDocument,
  GetPartnerBrandsDocument: () => GetPartnerBrandsDocument,
  GetPartnerByIdDocument: () => GetPartnerByIdDocument,
  GetPaymentCardsDocument: () => GetPaymentCardsDocument,
  GetPaymentSessionDocument: () => GetPaymentSessionDocument,
  GetPaymentStatusDocument: () => GetPaymentStatusDocument,
  GetProductByCodeDocument: () => GetProductByCodeDocument,
  GetTokenExCvvConfigDocument: () => GetTokenExCvvConfigDocument,
  GetTranslationsCountDocument: () => GetTranslationsCountDocument,
  GetTranslationsDocument: () => GetTranslationsDocument,
  GetUsersForPartnerDocument: () => GetUsersForPartnerDocument,
  GetValidInvitationFromTokenDocument: () => GetValidInvitationFromTokenDocument,
  InvitationUserType: () => InvitationUserType,
  IsInvitationTokenValidDocument: () => IsInvitationTokenValidDocument,
  IsoCountryCode: () => IsoCountryCode,
  JourneyLeg: () => JourneyLeg,
  LastEditedByType: () => LastEditedByType,
  LinkAccountDocument: () => LinkAccountDocument,
  LinkedAccountLifecycleStatus: () => LinkedAccountLifecycleStatus,
  LinkedAccountProvider: () => LinkedAccountProvider,
  LinkedAccountStatusUpdatedBy: () => LinkedAccountStatusUpdatedBy,
  LocaleCode: () => LocaleCode,
  LocationType: () => LocationType,
  MakePaymentDocument: () => MakePaymentDocument,
  MembershipPlanStatus: () => MembershipPlanStatus,
  MembershipStatus: () => MembershipStatus,
  MobileAppDataStatus: () => MobileAppDataStatus,
  OperationType: () => OperationType,
  Origin: () => Origin,
  OtpRequestStatus: () => OtpRequestStatus,
  OutletCategory: () => OutletCategory,
  OutletDraftWorkflowStage: () => OutletDraftWorkflowStage,
  OutletIdType: () => OutletIdType,
  OutletLocationDetailsSection: () => OutletLocationDetailsSection,
  OutletOpenStatus: () => OutletOpenStatus,
  OutletRegion: () => OutletRegion,
  OutletSetDataSourceTypes: () => OutletSetDataSourceTypes,
  OutletStatus: () => OutletStatus,
  OutletSubmissionDecision: () => OutletSubmissionDecision,
  OutletVersionStatus: () => OutletVersionStatus,
  OutletWorkflowStage: () => OutletWorkflowStage,
  OutletWorkflowStatus: () => OutletWorkflowStatus,
  PanStatus: () => PanStatus,
  PanTypes: () => PanTypes,
  PartnerBrandStatus: () => PartnerBrandStatus,
  PartnerRoleType: () => PartnerRoleType,
  PartnerUserStatus: () => PartnerUserStatus,
  PartnerUserType: () => PartnerUserType,
  PassengerType: () => PassengerType,
  PayByLinkBin: () => PayByLinkBin,
  PaymentCardBrand: () => PaymentCardBrand,
  PaymentCustomerStatus: () => PaymentCustomerStatus,
  PaymentMethod: () => PaymentMethod,
  PaymentMethodType: () => PaymentMethodType,
  PaymentMode: () => PaymentMode,
  PaymentOption: () => PaymentOption,
  PaymentProgramme: () => PaymentProgramme,
  PaymentProvider: () => PaymentProvider,
  PaymentRefundPriority: () => PaymentRefundPriority,
  PaymentRefundStatusResult: () => PaymentRefundStatusResult,
  PaymentRefundType: () => PaymentRefundType,
  PaymentSessionSource: () => PaymentSessionSource,
  PaymentStatusResult: () => PaymentStatusResult,
  PaymentType: () => PaymentType,
  PrimaryProductAccessType: () => PrimaryProductAccessType,
  ProductCategory: () => ProductCategory,
  ProductCostType: () => ProductCostType,
  ProductFamily: () => ProductFamily,
  ProductIdType: () => ProductIdType,
  ProductStage: () => ProductStage,
  ProductStatus: () => ProductStatus,
  ProductType: () => ProductType,
  ProductValuationDocument: () => ProductValuationDocument,
  Programme: () => Programme,
  Proposition: () => Proposition,
  PublishOutletDocument: () => PublishOutletDocument,
  RecordPartnerUserLoginDocument: () => RecordPartnerUserLoginDocument,
  RefundStatus: () => RefundStatus,
  RefundStatusReasonCode: () => RefundStatusReasonCode,
  RevertOutletDocument: () => RevertOutletDocument,
  ReviewLookupType: () => ReviewLookupType,
  ReviewOutletSubmissionDocument: () => ReviewOutletSubmissionDocument,
  SearchAirportsDocument: () => SearchAirportsDocument,
  SearchCatalogueDocument: () => SearchCatalogueDocument,
  SearchExperiencesDocument: () => SearchExperiencesDocument,
  SearchIsoCountryCode: () => SearchIsoCountryCode,
  SearchLocaleCode: () => SearchLocaleCode,
  SearchLocationType: () => SearchLocationType,
  SearchObjectType: () => SearchObjectType,
  SearchOutletCategory: () => SearchOutletCategory,
  SearchOutletRegion: () => SearchOutletRegion,
  SearchPassengerType: () => SearchPassengerType,
  SearchPrimaryProductAccessType: () => SearchPrimaryProductAccessType,
  SearchProductCategory: () => SearchProductCategory,
  SearchProductStatus: () => SearchProductStatus,
  SearchTranslationMemoryDocument: () => SearchTranslationMemoryDocument,
  SearchType: () => SearchType,
  SlotState: () => SlotState,
  SmokingPolicy: () => SmokingPolicy,
  SortBy: () => SortBy,
  SortField: () => SortField,
  SortOrder: () => SortOrder,
  Status: () => Status,
  StatusReasonCode: () => StatusReasonCode,
  StripeUiMode: () => StripeUiMode,
  SubmitOutletForApprovalDocument: () => SubmitOutletForApprovalDocument,
  SubmitTokenExTokenDocument: () => SubmitTokenExTokenDocument,
  Theme: () => Theme,
  Tier: () => Tier,
  TierCyclePeriod: () => TierCyclePeriod,
  TierDurationType: () => TierDurationType,
  TierExpiryAction: () => TierExpiryAction,
  TimezoneType: () => TimezoneType,
  TransactionInitiator: () => TransactionInitiator,
  TransactionType: () => TransactionType,
  TransferMethod: () => TransferMethod,
  TranslationIdType: () => TranslationIdType,
  TranslationStatus: () => TranslationStatus,
  TripLegType: () => TripLegType,
  TripPurpose: () => TripPurpose,
  TripSource: () => TripSource,
  TripState: () => TripState,
  TripType: () => TripType,
  UpdateCheckoutSessionDocument: () => UpdateCheckoutSessionDocument,
  UpdateConsumerDocument: () => UpdateConsumerDocument,
  UpdateOutletDocument: () => UpdateOutletDocument,
  UserMembershipOrderKey: () => UserMembershipOrderKey,
  ValuationProgramme: () => ValuationProgramme,
  VariationType: () => VariationType,
  VerifyPaymentWebAppDocument: () => VerifyPaymentWebAppDocument,
  VisitorCategory: () => VisitorCategory,
  VisitorType: () => VisitorType
});
module.exports = __toCommonJS(graphql_exports);
var ActivationStatus = /* @__PURE__ */ ((ActivationStatus2) => {
  ActivationStatus2["Active"] = "ACTIVE";
  ActivationStatus2["Cancelled"] = "CANCELLED";
  ActivationStatus2["Error"] = "ERROR";
  ActivationStatus2["Redeemed"] = "REDEEMED";
  return ActivationStatus2;
})(ActivationStatus || {});
var AddressType = /* @__PURE__ */ ((AddressType2) => {
  AddressType2["Billing"] = "BILLING";
  AddressType2["Home"] = "HOME";
  return AddressType2;
})(AddressType || {});
var AdmissionPer = /* @__PURE__ */ ((AdmissionPer2) => {
  AdmissionPer2["Adult"] = "adult";
  AdmissionPer2["Cardholder"] = "cardholder";
  return AdmissionPer2;
})(AdmissionPer || {});
var AffiliateProgramme = /* @__PURE__ */ ((AffiliateProgramme2) => {
  AffiliateProgramme2["LoungeKey"] = "LOUNGE_KEY";
  AffiliateProgramme2["LoungePass"] = "LOUNGE_PASS";
  AffiliateProgramme2["Mcae"] = "MCAE";
  AffiliateProgramme2["PriorityPass"] = "PRIORITY_PASS";
  return AffiliateProgramme2;
})(AffiliateProgramme || {});
var AmendmentStatus = /* @__PURE__ */ ((AmendmentStatus2) => {
  AmendmentStatus2["ChargeCompleted"] = "CHARGE_COMPLETED";
  AmendmentStatus2["ChargeFailed"] = "CHARGE_FAILED";
  AmendmentStatus2["ChargeInitialized"] = "CHARGE_INITIALIZED";
  AmendmentStatus2["Confirmed"] = "CONFIRMED";
  AmendmentStatus2["FailedToUpdateBookingRecord"] = "FAILED_TO_UPDATE_BOOKING_RECORD";
  AmendmentStatus2["Initialized"] = "INITIALIZED";
  AmendmentStatus2["RefundFailed"] = "REFUND_FAILED";
  AmendmentStatus2["SnaplogicAmendmentFailed"] = "SNAPLOGIC_AMENDMENT_FAILED";
  AmendmentStatus2["SnaplogicDataIsIncorrect"] = "SNAPLOGIC_DATA_IS_INCORRECT";
  return AmendmentStatus2;
})(AmendmentStatus || {});
var BookingFlowType = /* @__PURE__ */ ((BookingFlowType2) => {
  BookingFlowType2["Integrated"] = "INTEGRATED";
  BookingFlowType2["NonIntegrated"] = "NON_INTEGRATED";
  BookingFlowType2["PreAgreed"] = "PRE_AGREED";
  return BookingFlowType2;
})(BookingFlowType || {});
var BookingStatus = /* @__PURE__ */ ((BookingStatus2) => {
  BookingStatus2["Amended"] = "AMENDED";
  BookingStatus2["Booked"] = "BOOKED";
  BookingStatus2["CancelationFailed"] = "CANCELATION_FAILED";
  BookingStatus2["Cancelled"] = "CANCELLED";
  BookingStatus2["CheckedIn"] = "CHECKED_IN";
  BookingStatus2["CompletedVisit"] = "COMPLETED_VISIT";
  BookingStatus2["Confirmed"] = "CONFIRMED";
  BookingStatus2["Declined"] = "DECLINED";
  BookingStatus2["Errored"] = "ERRORED";
  BookingStatus2["Initialized"] = "INITIALIZED";
  BookingStatus2["NoShow"] = "NO_SHOW";
  BookingStatus2["PartiallyRefunded"] = "PARTIALLY_REFUNDED";
  BookingStatus2["Pending"] = "PENDING";
  BookingStatus2["Refunded"] = "REFUNDED";
  return BookingStatus2;
})(BookingStatus || {});
var BookingType = /* @__PURE__ */ ((BookingType2) => {
  BookingType2["Reservation"] = "RESERVATION";
  BookingType2["ReservationFeeOnly"] = "RESERVATION_FEE_ONLY";
  BookingType2["WalkUp"] = "WALK_UP";
  return BookingType2;
})(BookingType || {});
var BulkImportTranslationMemoryClassification = /* @__PURE__ */ ((BulkImportTranslationMemoryClassification2) => {
  BulkImportTranslationMemoryClassification2["AddLocale"] = "ADD_LOCALE";
  BulkImportTranslationMemoryClassification2["New"] = "NEW";
  BulkImportTranslationMemoryClassification2["Noop"] = "NOOP";
  BulkImportTranslationMemoryClassification2["OverwriteLocale"] = "OVERWRITE_LOCALE";
  BulkImportTranslationMemoryClassification2["Skipped"] = "SKIPPED";
  return BulkImportTranslationMemoryClassification2;
})(BulkImportTranslationMemoryClassification || {});
var BusinessUnit = /* @__PURE__ */ ((BusinessUnit2) => {
  BusinessUnit2["ColShLtd"] = "COL_SH_LTD";
  BusinessUnit2["Llp"] = "LLP";
  BusinessUnit2["PpApLtd"] = "PP_AP_LTD";
  BusinessUnit2["PpALtd"] = "PP_A_LTD";
  BusinessUnit2["PpInc"] = "PP_INC";
  BusinessUnit2["PpLtd"] = "PP_LTD";
  BusinessUnit2["Sac"] = "SAC";
  return BusinessUnit2;
})(BusinessUnit || {});
var Businessunit = /* @__PURE__ */ ((Businessunit2) => {
  Businessunit2["Llp"] = "LLP";
  Businessunit2["PpAp"] = "PP_AP";
  Businessunit2["PpApLtd"] = "PP_AP_LTD";
  Businessunit2["PpInc"] = "PP_INC";
  Businessunit2["PpLtd"] = "PP_LTD";
  return Businessunit2;
})(Businessunit || {});
var CalculationStatus = /* @__PURE__ */ ((CalculationStatus2) => {
  CalculationStatus2["Calculated"] = "CALCULATED";
  CalculationStatus2["FailedDependency"] = "FAILED_DEPENDENCY";
  return CalculationStatus2;
})(CalculationStatus || {});
var CatalogueDataOrigin = /* @__PURE__ */ ((CatalogueDataOrigin2) => {
  CatalogueDataOrigin2["CollinsonGroup"] = "COLLINSON_GROUP";
  CatalogueDataOrigin2["Upflex"] = "UPFLEX";
  return CatalogueDataOrigin2;
})(CatalogueDataOrigin || {});
var CatalogueLocale = /* @__PURE__ */ ((CatalogueLocale2) => {
  CatalogueLocale2["Ar"] = "ar";
  CatalogueLocale2["ArSa"] = "ar_SA";
  CatalogueLocale2["De"] = "de";
  CatalogueLocale2["DeDe"] = "de_DE";
  CatalogueLocale2["EnGb"] = "en_GB";
  CatalogueLocale2["Es"] = "es";
  CatalogueLocale2["Es_419"] = "es_419";
  CatalogueLocale2["FiFi"] = "fi_FI";
  CatalogueLocale2["Fr"] = "fr";
  CatalogueLocale2["FrCa"] = "fr_CA";
  CatalogueLocale2["FrFr"] = "fr_FR";
  CatalogueLocale2["Id"] = "id";
  CatalogueLocale2["IdId"] = "id_ID";
  CatalogueLocale2["It"] = "it";
  CatalogueLocale2["ItIt"] = "it_IT";
  CatalogueLocale2["Ja"] = "ja";
  CatalogueLocale2["JaJp"] = "ja_JP";
  CatalogueLocale2["Ko"] = "ko";
  CatalogueLocale2["KoKr"] = "ko_KR";
  CatalogueLocale2["Ms"] = "ms";
  CatalogueLocale2["MsMy"] = "ms_MY";
  CatalogueLocale2["Nl"] = "nl";
  CatalogueLocale2["NlNl"] = "nl_NL";
  CatalogueLocale2["Pl"] = "pl";
  CatalogueLocale2["PlPl"] = "pl_PL";
  CatalogueLocale2["Pt"] = "pt";
  CatalogueLocale2["PtBr"] = "pt_BR";
  CatalogueLocale2["PtPt"] = "pt_PT";
  CatalogueLocale2["Ru"] = "ru";
  CatalogueLocale2["RuRu"] = "ru_RU";
  CatalogueLocale2["Th"] = "th";
  CatalogueLocale2["ThTh"] = "th_TH";
  CatalogueLocale2["Tr"] = "tr";
  CatalogueLocale2["TrTr"] = "tr_TR";
  CatalogueLocale2["Uk"] = "uk";
  CatalogueLocale2["UkUa"] = "uk_UA";
  CatalogueLocale2["Vi"] = "vi";
  CatalogueLocale2["ViVn"] = "vi_VN";
  CatalogueLocale2["ZhCn"] = "zh_CN";
  CatalogueLocale2["ZhHant"] = "zh_Hant";
  CatalogueLocale2["ZhHantHk"] = "zh_Hant_HK";
  CatalogueLocale2["ZhHantTw"] = "zh_Hant_TW";
  return CatalogueLocale2;
})(CatalogueLocale || {});
var CatalogueLocationType = /* @__PURE__ */ ((CatalogueLocationType2) => {
  CatalogueLocationType2["Airport"] = "AIRPORT";
  CatalogueLocationType2["FerryStation"] = "FERRY_STATION";
  CatalogueLocationType2["RailwayStation"] = "RAILWAY_STATION";
  CatalogueLocationType2["Workspace"] = "WORKSPACE";
  return CatalogueLocationType2;
})(CatalogueLocationType || {});
var CatalogueProductType = /* @__PURE__ */ ((CatalogueProductType2) => {
  CatalogueProductType2["Affiliate"] = "AFFILIATE";
  CatalogueProductType2["Ancillary"] = "ANCILLARY";
  CatalogueProductType2["Package"] = "PACKAGE";
  CatalogueProductType2["Primary"] = "PRIMARY";
  return CatalogueProductType2;
})(CatalogueProductType || {});
var CatalogueProgramme = /* @__PURE__ */ ((CatalogueProgramme2) => {
  CatalogueProgramme2["LoungeKey"] = "LOUNGE_KEY";
  CatalogueProgramme2["LoungePass"] = "LOUNGE_PASS";
  CatalogueProgramme2["PpPreferred"] = "PP_PREFERRED";
  CatalogueProgramme2["PpPrivate"] = "PP_PRIVATE";
  CatalogueProgramme2["PriorityPass"] = "PRIORITY_PASS";
  return CatalogueProgramme2;
})(CatalogueProgramme || {});
var ChangeReason = /* @__PURE__ */ ((ChangeReason2) => {
  ChangeReason2["ClientTriggeredChange"] = "ClientTriggeredChange";
  ChangeReason2["ClientTriggeredDowngrade"] = "ClientTriggeredDowngrade";
  ChangeReason2["ClientTriggeredUpgrade"] = "ClientTriggeredUpgrade";
  return ChangeReason2;
})(ChangeReason || {});
var ChargeOwner = /* @__PURE__ */ ((ChargeOwner2) => {
  ChargeOwner2["CardHolder"] = "CARD_HOLDER";
  ChargeOwner2["Collinson"] = "COLLINSON";
  ChargeOwner2["Issuer"] = "ISSUER";
  ChargeOwner2["Network"] = "NETWORK";
  return ChargeOwner2;
})(ChargeOwner || {});
var ChatbotParticipantRole = /* @__PURE__ */ ((ChatbotParticipantRole2) => {
  ChatbotParticipantRole2["Assistant"] = "ASSISTANT";
  ChatbotParticipantRole2["Other"] = "OTHER";
  ChatbotParticipantRole2["Tool"] = "TOOL";
  ChatbotParticipantRole2["User"] = "USER";
  return ChatbotParticipantRole2;
})(ChatbotParticipantRole || {});
var ConsumerCostZone = /* @__PURE__ */ ((ConsumerCostZone2) => {
  ConsumerCostZone2["CostZone_1"] = "COST_ZONE_1";
  ConsumerCostZone2["CostZone_2"] = "COST_ZONE_2";
  ConsumerCostZone2["CostZone_3"] = "COST_ZONE_3";
  ConsumerCostZone2["CostZone_4"] = "COST_ZONE_4";
  ConsumerCostZone2["CostZone_5"] = "COST_ZONE_5";
  ConsumerCostZone2["CostZone_6"] = "COST_ZONE_6";
  ConsumerCostZone2["CostZone_7"] = "COST_ZONE_7";
  ConsumerCostZone2["CostZone_8"] = "COST_ZONE_8";
  ConsumerCostZone2["CostZone_9"] = "COST_ZONE_9";
  ConsumerCostZone2["CostZone_10"] = "COST_ZONE_10";
  ConsumerCostZone2["CostZone_11"] = "COST_ZONE_11";
  ConsumerCostZone2["CostZone_12"] = "COST_ZONE_12";
  ConsumerCostZone2["CostZone_13"] = "COST_ZONE_13";
  ConsumerCostZone2["CostZone_14"] = "COST_ZONE_14";
  ConsumerCostZone2["CostZone_15"] = "COST_ZONE_15";
  ConsumerCostZone2["CostZone_16"] = "COST_ZONE_16";
  ConsumerCostZone2["CostZone_17"] = "COST_ZONE_17";
  ConsumerCostZone2["CostZone_18"] = "COST_ZONE_18";
  ConsumerCostZone2["CostZone_19"] = "COST_ZONE_19";
  ConsumerCostZone2["CostZone_20"] = "COST_ZONE_20";
  ConsumerCostZone2["CostZone_21"] = "COST_ZONE_21";
  ConsumerCostZone2["CostZone_22"] = "COST_ZONE_22";
  ConsumerCostZone2["CostZone_23"] = "COST_ZONE_23";
  ConsumerCostZone2["CostZone_24"] = "COST_ZONE_24";
  ConsumerCostZone2["CostZone_25"] = "COST_ZONE_25";
  ConsumerCostZone2["CostZone_26"] = "COST_ZONE_26";
  ConsumerCostZone2["CostZone_27"] = "COST_ZONE_27";
  ConsumerCostZone2["CostZone_28"] = "COST_ZONE_28";
  ConsumerCostZone2["CostZone_29"] = "COST_ZONE_29";
  ConsumerCostZone2["CostZone_30"] = "COST_ZONE_30";
  ConsumerCostZone2["CostZone_31"] = "COST_ZONE_31";
  ConsumerCostZone2["CostZone_32"] = "COST_ZONE_32";
  ConsumerCostZone2["CostZone_33"] = "COST_ZONE_33";
  ConsumerCostZone2["CostZone_34"] = "COST_ZONE_34";
  ConsumerCostZone2["CostZone_35"] = "COST_ZONE_35";
  ConsumerCostZone2["CostZone_36"] = "COST_ZONE_36";
  ConsumerCostZone2["CostZone_37"] = "COST_ZONE_37";
  ConsumerCostZone2["CostZone_38"] = "COST_ZONE_38";
  ConsumerCostZone2["CostZone_39"] = "COST_ZONE_39";
  ConsumerCostZone2["CostZone_40"] = "COST_ZONE_40";
  ConsumerCostZone2["CostZoneA"] = "COST_ZONE_A";
  ConsumerCostZone2["CostZoneB"] = "COST_ZONE_B";
  ConsumerCostZone2["CostZoneC"] = "COST_ZONE_C";
  return ConsumerCostZone2;
})(ConsumerCostZone || {});
var ConsumerLocationType = /* @__PURE__ */ ((ConsumerLocationType2) => {
  ConsumerLocationType2["Airport"] = "AIRPORT";
  ConsumerLocationType2["FerryStation"] = "FERRY_STATION";
  ConsumerLocationType2["RailwayStation"] = "RAILWAY_STATION";
  return ConsumerLocationType2;
})(ConsumerLocationType || {});
var ConsumerOutletRegion = /* @__PURE__ */ ((ConsumerOutletRegion2) => {
  ConsumerOutletRegion2["Americas"] = "AMERICAS";
  ConsumerOutletRegion2["Apac"] = "APAC";
  ConsumerOutletRegion2["Emea"] = "EMEA";
  ConsumerOutletRegion2["Global"] = "GLOBAL";
  return ConsumerOutletRegion2;
})(ConsumerOutletRegion || {});
var ConsumerPassengerType = /* @__PURE__ */ ((ConsumerPassengerType2) => {
  ConsumerPassengerType2["Domestic"] = "DOMESTIC";
  ConsumerPassengerType2["International"] = "INTERNATIONAL";
  ConsumerPassengerType2["InTransit"] = "IN_TRANSIT";
  ConsumerPassengerType2["NonSchengen"] = "NON_SCHENGEN";
  ConsumerPassengerType2["Schengen"] = "SCHENGEN";
  ConsumerPassengerType2["UsTransborder"] = "US_TRANSBORDER";
  return ConsumerPassengerType2;
})(ConsumerPassengerType || {});
var ConsumerPrimaryProductAccessType = /* @__PURE__ */ ((ConsumerPrimaryProductAccessType2) => {
  ConsumerPrimaryProductAccessType2["Reservation"] = "RESERVATION";
  ConsumerPrimaryProductAccessType2["ReservationFeeOnly"] = "RESERVATION_FEE_ONLY";
  ConsumerPrimaryProductAccessType2["WalkUp"] = "WALK_UP";
  return ConsumerPrimaryProductAccessType2;
})(ConsumerPrimaryProductAccessType || {});
var ConsumerProductCategory = /* @__PURE__ */ ((ConsumerProductCategory2) => {
  ConsumerProductCategory2["Eat"] = "EAT";
  ConsumerProductCategory2["FastTrack"] = "FAST_TRACK";
  ConsumerProductCategory2["Lounge"] = "LOUNGE";
  ConsumerProductCategory2["Rail"] = "RAIL";
  ConsumerProductCategory2["Refresh"] = "REFRESH";
  ConsumerProductCategory2["Rest"] = "REST";
  ConsumerProductCategory2["Unwind"] = "UNWIND";
  return ConsumerProductCategory2;
})(ConsumerProductCategory || {});
var ConsumerProgramme = /* @__PURE__ */ ((ConsumerProgramme2) => {
  ConsumerProgramme2["LoungeKey"] = "LOUNGE_KEY";
  ConsumerProgramme2["LoungePass"] = "LOUNGE_PASS";
  ConsumerProgramme2["PpPreferred"] = "PP_PREFERRED";
  ConsumerProgramme2["PpPrivate"] = "PP_PRIVATE";
  ConsumerProgramme2["PriorityPass"] = "PRIORITY_PASS";
  return ConsumerProgramme2;
})(ConsumerProgramme || {});
var ConsumerTier = /* @__PURE__ */ ((ConsumerTier2) => {
  ConsumerTier2["Black"] = "BLACK";
  ConsumerTier2["Gold"] = "GOLD";
  ConsumerTier2["LowCost"] = "LOW_COST";
  ConsumerTier2["Private"] = "PRIVATE";
  return ConsumerTier2;
})(ConsumerTier || {});
var CostZone = /* @__PURE__ */ ((CostZone2) => {
  CostZone2["CostZone_1"] = "COST_ZONE_1";
  CostZone2["CostZone_2"] = "COST_ZONE_2";
  CostZone2["CostZone_3"] = "COST_ZONE_3";
  CostZone2["CostZone_4"] = "COST_ZONE_4";
  CostZone2["CostZone_5"] = "COST_ZONE_5";
  CostZone2["CostZone_6"] = "COST_ZONE_6";
  CostZone2["CostZone_7"] = "COST_ZONE_7";
  CostZone2["CostZone_8"] = "COST_ZONE_8";
  CostZone2["CostZone_9"] = "COST_ZONE_9";
  CostZone2["CostZone_10"] = "COST_ZONE_10";
  CostZone2["CostZone_11"] = "COST_ZONE_11";
  CostZone2["CostZone_12"] = "COST_ZONE_12";
  CostZone2["CostZone_13"] = "COST_ZONE_13";
  CostZone2["CostZone_14"] = "COST_ZONE_14";
  CostZone2["CostZone_15"] = "COST_ZONE_15";
  CostZone2["CostZone_16"] = "COST_ZONE_16";
  CostZone2["CostZone_17"] = "COST_ZONE_17";
  CostZone2["CostZone_18"] = "COST_ZONE_18";
  CostZone2["CostZone_19"] = "COST_ZONE_19";
  CostZone2["CostZone_20"] = "COST_ZONE_20";
  CostZone2["CostZone_21"] = "COST_ZONE_21";
  CostZone2["CostZone_22"] = "COST_ZONE_22";
  CostZone2["CostZone_23"] = "COST_ZONE_23";
  CostZone2["CostZone_24"] = "COST_ZONE_24";
  CostZone2["CostZone_25"] = "COST_ZONE_25";
  CostZone2["CostZone_26"] = "COST_ZONE_26";
  CostZone2["CostZone_27"] = "COST_ZONE_27";
  CostZone2["CostZone_28"] = "COST_ZONE_28";
  CostZone2["CostZone_29"] = "COST_ZONE_29";
  CostZone2["CostZone_30"] = "COST_ZONE_30";
  CostZone2["CostZone_31"] = "COST_ZONE_31";
  CostZone2["CostZone_32"] = "COST_ZONE_32";
  CostZone2["CostZone_33"] = "COST_ZONE_33";
  CostZone2["CostZone_34"] = "COST_ZONE_34";
  CostZone2["CostZone_35"] = "COST_ZONE_35";
  CostZone2["CostZone_36"] = "COST_ZONE_36";
  CostZone2["CostZone_37"] = "COST_ZONE_37";
  CostZone2["CostZone_38"] = "COST_ZONE_38";
  CostZone2["CostZone_39"] = "COST_ZONE_39";
  CostZone2["CostZone_40"] = "COST_ZONE_40";
  CostZone2["CostZoneA"] = "COST_ZONE_A";
  CostZone2["CostZoneB"] = "COST_ZONE_B";
  CostZone2["CostZoneC"] = "COST_ZONE_C";
  return CostZone2;
})(CostZone || {});
var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2["Eur"] = "EUR";
  Currency2["Gbp"] = "GBP";
  Currency2["Hkd"] = "HKD";
  Currency2["Inr"] = "INR";
  Currency2["Jpy"] = "JPY";
  Currency2["Usd"] = "USD";
  return Currency2;
})(Currency || {});
var DealIneligibilityReason = /* @__PURE__ */ ((DealIneligibilityReason2) => {
  DealIneligibilityReason2["ProductNotPartOfDeal"] = "PRODUCT_NOT_PART_OF_DEAL";
  return DealIneligibilityReason2;
})(DealIneligibilityReason || {});
var EnrollmentStatus = /* @__PURE__ */ ((EnrollmentStatus2) => {
  EnrollmentStatus2["Active"] = "ACTIVE";
  EnrollmentStatus2["Blocked"] = "BLOCKED";
  EnrollmentStatus2["Hold"] = "HOLD";
  return EnrollmentStatus2;
})(EnrollmentStatus || {});
var EntitlementIsoCountryCode = /* @__PURE__ */ ((EntitlementIsoCountryCode2) => {
  EntitlementIsoCountryCode2["Abw"] = "ABW";
  EntitlementIsoCountryCode2["Afg"] = "AFG";
  EntitlementIsoCountryCode2["Ago"] = "AGO";
  EntitlementIsoCountryCode2["Aia"] = "AIA";
  EntitlementIsoCountryCode2["Ala"] = "ALA";
  EntitlementIsoCountryCode2["Alb"] = "ALB";
  EntitlementIsoCountryCode2["And"] = "AND";
  EntitlementIsoCountryCode2["Ant"] = "ANT";
  EntitlementIsoCountryCode2["Are"] = "ARE";
  EntitlementIsoCountryCode2["Arg"] = "ARG";
  EntitlementIsoCountryCode2["Arm"] = "ARM";
  EntitlementIsoCountryCode2["Asm"] = "ASM";
  EntitlementIsoCountryCode2["Ata"] = "ATA";
  EntitlementIsoCountryCode2["Atf"] = "ATF";
  EntitlementIsoCountryCode2["Atg"] = "ATG";
  EntitlementIsoCountryCode2["Aus"] = "AUS";
  EntitlementIsoCountryCode2["Aut"] = "AUT";
  EntitlementIsoCountryCode2["Aze"] = "AZE";
  EntitlementIsoCountryCode2["Bdi"] = "BDI";
  EntitlementIsoCountryCode2["Bel"] = "BEL";
  EntitlementIsoCountryCode2["Ben"] = "BEN";
  EntitlementIsoCountryCode2["Bes"] = "BES";
  EntitlementIsoCountryCode2["Bfa"] = "BFA";
  EntitlementIsoCountryCode2["Bgd"] = "BGD";
  EntitlementIsoCountryCode2["Bgr"] = "BGR";
  EntitlementIsoCountryCode2["Bhr"] = "BHR";
  EntitlementIsoCountryCode2["Bhs"] = "BHS";
  EntitlementIsoCountryCode2["Bih"] = "BIH";
  EntitlementIsoCountryCode2["Blm"] = "BLM";
  EntitlementIsoCountryCode2["Blr"] = "BLR";
  EntitlementIsoCountryCode2["Blz"] = "BLZ";
  EntitlementIsoCountryCode2["Bmu"] = "BMU";
  EntitlementIsoCountryCode2["Bol"] = "BOL";
  EntitlementIsoCountryCode2["Bra"] = "BRA";
  EntitlementIsoCountryCode2["Brb"] = "BRB";
  EntitlementIsoCountryCode2["Brn"] = "BRN";
  EntitlementIsoCountryCode2["Btn"] = "BTN";
  EntitlementIsoCountryCode2["Bvt"] = "BVT";
  EntitlementIsoCountryCode2["Bwa"] = "BWA";
  EntitlementIsoCountryCode2["Caf"] = "CAF";
  EntitlementIsoCountryCode2["Can"] = "CAN";
  EntitlementIsoCountryCode2["Cck"] = "CCK";
  EntitlementIsoCountryCode2["Che"] = "CHE";
  EntitlementIsoCountryCode2["Chl"] = "CHL";
  EntitlementIsoCountryCode2["Chn"] = "CHN";
  EntitlementIsoCountryCode2["Civ"] = "CIV";
  EntitlementIsoCountryCode2["Cmr"] = "CMR";
  EntitlementIsoCountryCode2["Cod"] = "COD";
  EntitlementIsoCountryCode2["Cog"] = "COG";
  EntitlementIsoCountryCode2["Cok"] = "COK";
  EntitlementIsoCountryCode2["Col"] = "COL";
  EntitlementIsoCountryCode2["Com"] = "COM";
  EntitlementIsoCountryCode2["Cpv"] = "CPV";
  EntitlementIsoCountryCode2["Cri"] = "CRI";
  EntitlementIsoCountryCode2["Cub"] = "CUB";
  EntitlementIsoCountryCode2["Cuw"] = "CUW";
  EntitlementIsoCountryCode2["Cxr"] = "CXR";
  EntitlementIsoCountryCode2["Cym"] = "CYM";
  EntitlementIsoCountryCode2["Cyp"] = "CYP";
  EntitlementIsoCountryCode2["Cze"] = "CZE";
  EntitlementIsoCountryCode2["Deu"] = "DEU";
  EntitlementIsoCountryCode2["Dji"] = "DJI";
  EntitlementIsoCountryCode2["Dma"] = "DMA";
  EntitlementIsoCountryCode2["Dnk"] = "DNK";
  EntitlementIsoCountryCode2["Dom"] = "DOM";
  EntitlementIsoCountryCode2["Dza"] = "DZA";
  EntitlementIsoCountryCode2["Ecu"] = "ECU";
  EntitlementIsoCountryCode2["Egy"] = "EGY";
  EntitlementIsoCountryCode2["Eri"] = "ERI";
  EntitlementIsoCountryCode2["Esh"] = "ESH";
  EntitlementIsoCountryCode2["Esp"] = "ESP";
  EntitlementIsoCountryCode2["Est"] = "EST";
  EntitlementIsoCountryCode2["Eth"] = "ETH";
  EntitlementIsoCountryCode2["Fin"] = "FIN";
  EntitlementIsoCountryCode2["Fji"] = "FJI";
  EntitlementIsoCountryCode2["Flk"] = "FLK";
  EntitlementIsoCountryCode2["Fra"] = "FRA";
  EntitlementIsoCountryCode2["Fro"] = "FRO";
  EntitlementIsoCountryCode2["Fsm"] = "FSM";
  EntitlementIsoCountryCode2["Gab"] = "GAB";
  EntitlementIsoCountryCode2["Gbr"] = "GBR";
  EntitlementIsoCountryCode2["Geo"] = "GEO";
  EntitlementIsoCountryCode2["Ggy"] = "GGY";
  EntitlementIsoCountryCode2["Gha"] = "GHA";
  EntitlementIsoCountryCode2["Gib"] = "GIB";
  EntitlementIsoCountryCode2["Gin"] = "GIN";
  EntitlementIsoCountryCode2["Glp"] = "GLP";
  EntitlementIsoCountryCode2["Gmb"] = "GMB";
  EntitlementIsoCountryCode2["Gnb"] = "GNB";
  EntitlementIsoCountryCode2["Gnq"] = "GNQ";
  EntitlementIsoCountryCode2["Grc"] = "GRC";
  EntitlementIsoCountryCode2["Grd"] = "GRD";
  EntitlementIsoCountryCode2["Grl"] = "GRL";
  EntitlementIsoCountryCode2["Gtm"] = "GTM";
  EntitlementIsoCountryCode2["Guf"] = "GUF";
  EntitlementIsoCountryCode2["Gum"] = "GUM";
  EntitlementIsoCountryCode2["Guy"] = "GUY";
  EntitlementIsoCountryCode2["Hkg"] = "HKG";
  EntitlementIsoCountryCode2["Hmd"] = "HMD";
  EntitlementIsoCountryCode2["Hnd"] = "HND";
  EntitlementIsoCountryCode2["Hrv"] = "HRV";
  EntitlementIsoCountryCode2["Hti"] = "HTI";
  EntitlementIsoCountryCode2["Hun"] = "HUN";
  EntitlementIsoCountryCode2["Idn"] = "IDN";
  EntitlementIsoCountryCode2["Imn"] = "IMN";
  EntitlementIsoCountryCode2["Ind"] = "IND";
  EntitlementIsoCountryCode2["Iot"] = "IOT";
  EntitlementIsoCountryCode2["Irl"] = "IRL";
  EntitlementIsoCountryCode2["Irn"] = "IRN";
  EntitlementIsoCountryCode2["Irq"] = "IRQ";
  EntitlementIsoCountryCode2["Isl"] = "ISL";
  EntitlementIsoCountryCode2["Isr"] = "ISR";
  EntitlementIsoCountryCode2["Ita"] = "ITA";
  EntitlementIsoCountryCode2["Jam"] = "JAM";
  EntitlementIsoCountryCode2["Jey"] = "JEY";
  EntitlementIsoCountryCode2["Jor"] = "JOR";
  EntitlementIsoCountryCode2["Jpn"] = "JPN";
  EntitlementIsoCountryCode2["Kaz"] = "KAZ";
  EntitlementIsoCountryCode2["Ken"] = "KEN";
  EntitlementIsoCountryCode2["Kgz"] = "KGZ";
  EntitlementIsoCountryCode2["Khm"] = "KHM";
  EntitlementIsoCountryCode2["Kir"] = "KIR";
  EntitlementIsoCountryCode2["Kna"] = "KNA";
  EntitlementIsoCountryCode2["Kor"] = "KOR";
  EntitlementIsoCountryCode2["Kwt"] = "KWT";
  EntitlementIsoCountryCode2["Lao"] = "LAO";
  EntitlementIsoCountryCode2["Lbn"] = "LBN";
  EntitlementIsoCountryCode2["Lbr"] = "LBR";
  EntitlementIsoCountryCode2["Lby"] = "LBY";
  EntitlementIsoCountryCode2["Lca"] = "LCA";
  EntitlementIsoCountryCode2["Lie"] = "LIE";
  EntitlementIsoCountryCode2["Lka"] = "LKA";
  EntitlementIsoCountryCode2["Lso"] = "LSO";
  EntitlementIsoCountryCode2["Ltu"] = "LTU";
  EntitlementIsoCountryCode2["Lux"] = "LUX";
  EntitlementIsoCountryCode2["Lva"] = "LVA";
  EntitlementIsoCountryCode2["Mac"] = "MAC";
  EntitlementIsoCountryCode2["Maf"] = "MAF";
  EntitlementIsoCountryCode2["Mar"] = "MAR";
  EntitlementIsoCountryCode2["Mco"] = "MCO";
  EntitlementIsoCountryCode2["Mda"] = "MDA";
  EntitlementIsoCountryCode2["Mdg"] = "MDG";
  EntitlementIsoCountryCode2["Mdv"] = "MDV";
  EntitlementIsoCountryCode2["Mex"] = "MEX";
  EntitlementIsoCountryCode2["Mhl"] = "MHL";
  EntitlementIsoCountryCode2["Mkd"] = "MKD";
  EntitlementIsoCountryCode2["Mli"] = "MLI";
  EntitlementIsoCountryCode2["Mlt"] = "MLT";
  EntitlementIsoCountryCode2["Mmr"] = "MMR";
  EntitlementIsoCountryCode2["Mne"] = "MNE";
  EntitlementIsoCountryCode2["Mng"] = "MNG";
  EntitlementIsoCountryCode2["Mnp"] = "MNP";
  EntitlementIsoCountryCode2["Moz"] = "MOZ";
  EntitlementIsoCountryCode2["Mrt"] = "MRT";
  EntitlementIsoCountryCode2["Msr"] = "MSR";
  EntitlementIsoCountryCode2["Mtq"] = "MTQ";
  EntitlementIsoCountryCode2["Mus"] = "MUS";
  EntitlementIsoCountryCode2["Mwi"] = "MWI";
  EntitlementIsoCountryCode2["Mys"] = "MYS";
  EntitlementIsoCountryCode2["Myt"] = "MYT";
  EntitlementIsoCountryCode2["Nam"] = "NAM";
  EntitlementIsoCountryCode2["Ncl"] = "NCL";
  EntitlementIsoCountryCode2["Ner"] = "NER";
  EntitlementIsoCountryCode2["Nfk"] = "NFK";
  EntitlementIsoCountryCode2["Nga"] = "NGA";
  EntitlementIsoCountryCode2["Nic"] = "NIC";
  EntitlementIsoCountryCode2["Niu"] = "NIU";
  EntitlementIsoCountryCode2["Nld"] = "NLD";
  EntitlementIsoCountryCode2["Nor"] = "NOR";
  EntitlementIsoCountryCode2["Npl"] = "NPL";
  EntitlementIsoCountryCode2["Nru"] = "NRU";
  EntitlementIsoCountryCode2["Nzl"] = "NZL";
  EntitlementIsoCountryCode2["Omn"] = "OMN";
  EntitlementIsoCountryCode2["Pak"] = "PAK";
  EntitlementIsoCountryCode2["Pan"] = "PAN";
  EntitlementIsoCountryCode2["Pcn"] = "PCN";
  EntitlementIsoCountryCode2["Per"] = "PER";
  EntitlementIsoCountryCode2["Phl"] = "PHL";
  EntitlementIsoCountryCode2["Plw"] = "PLW";
  EntitlementIsoCountryCode2["Png"] = "PNG";
  EntitlementIsoCountryCode2["Pol"] = "POL";
  EntitlementIsoCountryCode2["Pri"] = "PRI";
  EntitlementIsoCountryCode2["Prk"] = "PRK";
  EntitlementIsoCountryCode2["Prt"] = "PRT";
  EntitlementIsoCountryCode2["Pry"] = "PRY";
  EntitlementIsoCountryCode2["Pse"] = "PSE";
  EntitlementIsoCountryCode2["Pyf"] = "PYF";
  EntitlementIsoCountryCode2["Qat"] = "QAT";
  EntitlementIsoCountryCode2["Reu"] = "REU";
  EntitlementIsoCountryCode2["Rou"] = "ROU";
  EntitlementIsoCountryCode2["Rus"] = "RUS";
  EntitlementIsoCountryCode2["Rwa"] = "RWA";
  EntitlementIsoCountryCode2["Sau"] = "SAU";
  EntitlementIsoCountryCode2["Sdn"] = "SDN";
  EntitlementIsoCountryCode2["Sen"] = "SEN";
  EntitlementIsoCountryCode2["Sgp"] = "SGP";
  EntitlementIsoCountryCode2["Sgs"] = "SGS";
  EntitlementIsoCountryCode2["Shn"] = "SHN";
  EntitlementIsoCountryCode2["Sjm"] = "SJM";
  EntitlementIsoCountryCode2["Slb"] = "SLB";
  EntitlementIsoCountryCode2["Sle"] = "SLE";
  EntitlementIsoCountryCode2["Slv"] = "SLV";
  EntitlementIsoCountryCode2["Smr"] = "SMR";
  EntitlementIsoCountryCode2["Som"] = "SOM";
  EntitlementIsoCountryCode2["Spm"] = "SPM";
  EntitlementIsoCountryCode2["Srb"] = "SRB";
  EntitlementIsoCountryCode2["Ssd"] = "SSD";
  EntitlementIsoCountryCode2["Stp"] = "STP";
  EntitlementIsoCountryCode2["Sur"] = "SUR";
  EntitlementIsoCountryCode2["Svk"] = "SVK";
  EntitlementIsoCountryCode2["Svn"] = "SVN";
  EntitlementIsoCountryCode2["Swe"] = "SWE";
  EntitlementIsoCountryCode2["Swz"] = "SWZ";
  EntitlementIsoCountryCode2["Sxm"] = "SXM";
  EntitlementIsoCountryCode2["Syc"] = "SYC";
  EntitlementIsoCountryCode2["Syr"] = "SYR";
  EntitlementIsoCountryCode2["Tca"] = "TCA";
  EntitlementIsoCountryCode2["Tcd"] = "TCD";
  EntitlementIsoCountryCode2["Tgo"] = "TGO";
  EntitlementIsoCountryCode2["Tha"] = "THA";
  EntitlementIsoCountryCode2["Tjk"] = "TJK";
  EntitlementIsoCountryCode2["Tkl"] = "TKL";
  EntitlementIsoCountryCode2["Tkm"] = "TKM";
  EntitlementIsoCountryCode2["Tls"] = "TLS";
  EntitlementIsoCountryCode2["Ton"] = "TON";
  EntitlementIsoCountryCode2["Tto"] = "TTO";
  EntitlementIsoCountryCode2["Tun"] = "TUN";
  EntitlementIsoCountryCode2["Tur"] = "TUR";
  EntitlementIsoCountryCode2["Tuv"] = "TUV";
  EntitlementIsoCountryCode2["Twn"] = "TWN";
  EntitlementIsoCountryCode2["Tza"] = "TZA";
  EntitlementIsoCountryCode2["Uga"] = "UGA";
  EntitlementIsoCountryCode2["Ukr"] = "UKR";
  EntitlementIsoCountryCode2["Umi"] = "UMI";
  EntitlementIsoCountryCode2["Ury"] = "URY";
  EntitlementIsoCountryCode2["Usa"] = "USA";
  EntitlementIsoCountryCode2["Uzb"] = "UZB";
  EntitlementIsoCountryCode2["Vat"] = "VAT";
  EntitlementIsoCountryCode2["Vct"] = "VCT";
  EntitlementIsoCountryCode2["Ven"] = "VEN";
  EntitlementIsoCountryCode2["Vgb"] = "VGB";
  EntitlementIsoCountryCode2["Vir"] = "VIR";
  EntitlementIsoCountryCode2["Vnm"] = "VNM";
  EntitlementIsoCountryCode2["Vut"] = "VUT";
  EntitlementIsoCountryCode2["Wlf"] = "WLF";
  EntitlementIsoCountryCode2["Wsm"] = "WSM";
  EntitlementIsoCountryCode2["Yem"] = "YEM";
  EntitlementIsoCountryCode2["Zaf"] = "ZAF";
  EntitlementIsoCountryCode2["Zmb"] = "ZMB";
  EntitlementIsoCountryCode2["Zwe"] = "ZWE";
  return EntitlementIsoCountryCode2;
})(EntitlementIsoCountryCode || {});
var EntitlementLevel = /* @__PURE__ */ ((EntitlementLevel2) => {
  EntitlementLevel2["Deal"] = "Deal";
  EntitlementLevel2["Tier"] = "Tier";
  return EntitlementLevel2;
})(EntitlementLevel || {});
var EntitlementLocationType = /* @__PURE__ */ ((EntitlementLocationType2) => {
  EntitlementLocationType2["Airport"] = "AIRPORT";
  EntitlementLocationType2["FerryStation"] = "FERRY_STATION";
  EntitlementLocationType2["RailwayStation"] = "RAILWAY_STATION";
  return EntitlementLocationType2;
})(EntitlementLocationType || {});
var EntitlementOutletRegion = /* @__PURE__ */ ((EntitlementOutletRegion2) => {
  EntitlementOutletRegion2["Americas"] = "AMERICAS";
  EntitlementOutletRegion2["Apac"] = "APAC";
  EntitlementOutletRegion2["Emea"] = "EMEA";
  EntitlementOutletRegion2["Global"] = "GLOBAL";
  return EntitlementOutletRegion2;
})(EntitlementOutletRegion || {});
var EntitlementPassengerType = /* @__PURE__ */ ((EntitlementPassengerType2) => {
  EntitlementPassengerType2["Domestic"] = "DOMESTIC";
  EntitlementPassengerType2["International"] = "INTERNATIONAL";
  EntitlementPassengerType2["InTransit"] = "IN_TRANSIT";
  EntitlementPassengerType2["NonSchengen"] = "NON_SCHENGEN";
  EntitlementPassengerType2["Schengen"] = "SCHENGEN";
  EntitlementPassengerType2["UsTransborder"] = "US_TRANSBORDER";
  return EntitlementPassengerType2;
})(EntitlementPassengerType || {});
var EntitlementProductAccessType = /* @__PURE__ */ ((EntitlementProductAccessType2) => {
  EntitlementProductAccessType2["Reservation"] = "RESERVATION";
  EntitlementProductAccessType2["ReservationFeeOnly"] = "RESERVATION_FEE_ONLY";
  EntitlementProductAccessType2["WalkUp"] = "WALK_UP";
  return EntitlementProductAccessType2;
})(EntitlementProductAccessType || {});
var EntitlementProductCategory = /* @__PURE__ */ ((EntitlementProductCategory2) => {
  EntitlementProductCategory2["Eat"] = "EAT";
  EntitlementProductCategory2["FastTrack"] = "FAST_TRACK";
  EntitlementProductCategory2["Lounge"] = "LOUNGE";
  EntitlementProductCategory2["Rail"] = "RAIL";
  EntitlementProductCategory2["Refresh"] = "REFRESH";
  EntitlementProductCategory2["Rest"] = "REST";
  EntitlementProductCategory2["Unwind"] = "UNWIND";
  return EntitlementProductCategory2;
})(EntitlementProductCategory || {});
var EntitlementProgramme = /* @__PURE__ */ ((EntitlementProgramme2) => {
  EntitlementProgramme2["LoungeKey"] = "LOUNGE_KEY";
  EntitlementProgramme2["LoungePass"] = "LOUNGE_PASS";
  EntitlementProgramme2["PpPreferred"] = "PP_PREFERRED";
  EntitlementProgramme2["PpPrivate"] = "PP_PRIVATE";
  EntitlementProgramme2["PriorityPass"] = "PRIORITY_PASS";
  return EntitlementProgramme2;
})(EntitlementProgramme || {});
var EntitlementSelectionMode = /* @__PURE__ */ ((EntitlementSelectionMode2) => {
  EntitlementSelectionMode2["Explicit"] = "EXPLICIT";
  EntitlementSelectionMode2["Implicit"] = "IMPLICIT";
  return EntitlementSelectionMode2;
})(EntitlementSelectionMode || {});
var EntitlementStatus = /* @__PURE__ */ ((EntitlementStatus2) => {
  EntitlementStatus2["Active"] = "ACTIVE";
  EntitlementStatus2["Forfeited"] = "FORFEITED";
  EntitlementStatus2["Redeemed"] = "REDEEMED";
  EntitlementStatus2["Reserved"] = "RESERVED";
  return EntitlementStatus2;
})(EntitlementStatus || {});
var ExceptionType = /* @__PURE__ */ ((ExceptionType2) => {
  ExceptionType2["ClosedUntilFurtherNotice"] = "CLOSED_UNTIL_FURTHER_NOTICE";
  ExceptionType2["DatePeriod"] = "DATE_PERIOD";
  ExceptionType2["ModifiedUntilFurtherNotice"] = "MODIFIED_UNTIL_FURTHER_NOTICE";
  ExceptionType2["RecurringDate"] = "RECURRING_DATE";
  ExceptionType2["RecurringDatePeriod"] = "RECURRING_DATE_PERIOD";
  ExceptionType2["SpecificDate"] = "SPECIFIC_DATE";
  return ExceptionType2;
})(ExceptionType || {});
var ExperienceCategory = /* @__PURE__ */ ((ExperienceCategory2) => {
  ExperienceCategory2["AirportExperience"] = "AIRPORT_EXPERIENCE";
  return ExperienceCategory2;
})(ExperienceCategory || {});
var ExperienceType = /* @__PURE__ */ ((ExperienceType2) => {
  ExperienceType2["Lounge"] = "LOUNGE";
  return ExperienceType2;
})(ExperienceType || {});
var FakeDoorInterest = /* @__PURE__ */ ((FakeDoorInterest2) => {
  FakeDoorInterest2["DoNotKnow"] = "DO_NOT_KNOW";
  FakeDoorInterest2["Interested"] = "INTERESTED";
  FakeDoorInterest2["NotInterested"] = "NOT_INTERESTED";
  return FakeDoorInterest2;
})(FakeDoorInterest || {});
var FakeDoorOs = /* @__PURE__ */ ((FakeDoorOs2) => {
  FakeDoorOs2["Android"] = "ANDROID";
  FakeDoorOs2["Ios"] = "IOS";
  return FakeDoorOs2;
})(FakeDoorOs || {});
var FakeDoorType = /* @__PURE__ */ ((FakeDoorType2) => {
  FakeDoorType2["TripForwardEmail"] = "TRIP_FORWARD_EMAIL";
  FakeDoorType2["TripInboxSync"] = "TRIP_INBOX_SYNC";
  return FakeDoorType2;
})(FakeDoorType || {});
var FavouriteEntityType = /* @__PURE__ */ ((FavouriteEntityType2) => {
  FavouriteEntityType2["Airport"] = "airport";
  FavouriteEntityType2["Outlet"] = "outlet";
  return FavouriteEntityType2;
})(FavouriteEntityType || {});
var IsoCountryCode = /* @__PURE__ */ ((IsoCountryCode2) => {
  IsoCountryCode2["Abw"] = "ABW";
  IsoCountryCode2["Afg"] = "AFG";
  IsoCountryCode2["Ago"] = "AGO";
  IsoCountryCode2["Aia"] = "AIA";
  IsoCountryCode2["Ala"] = "ALA";
  IsoCountryCode2["Alb"] = "ALB";
  IsoCountryCode2["And"] = "AND";
  IsoCountryCode2["Ant"] = "ANT";
  IsoCountryCode2["Are"] = "ARE";
  IsoCountryCode2["Arg"] = "ARG";
  IsoCountryCode2["Arm"] = "ARM";
  IsoCountryCode2["Asm"] = "ASM";
  IsoCountryCode2["Ata"] = "ATA";
  IsoCountryCode2["Atf"] = "ATF";
  IsoCountryCode2["Atg"] = "ATG";
  IsoCountryCode2["Aus"] = "AUS";
  IsoCountryCode2["Aut"] = "AUT";
  IsoCountryCode2["Aze"] = "AZE";
  IsoCountryCode2["Bdi"] = "BDI";
  IsoCountryCode2["Bel"] = "BEL";
  IsoCountryCode2["Ben"] = "BEN";
  IsoCountryCode2["Bes"] = "BES";
  IsoCountryCode2["Bfa"] = "BFA";
  IsoCountryCode2["Bgd"] = "BGD";
  IsoCountryCode2["Bgr"] = "BGR";
  IsoCountryCode2["Bhr"] = "BHR";
  IsoCountryCode2["Bhs"] = "BHS";
  IsoCountryCode2["Bih"] = "BIH";
  IsoCountryCode2["Blm"] = "BLM";
  IsoCountryCode2["Blr"] = "BLR";
  IsoCountryCode2["Blz"] = "BLZ";
  IsoCountryCode2["Bmu"] = "BMU";
  IsoCountryCode2["Bol"] = "BOL";
  IsoCountryCode2["Bra"] = "BRA";
  IsoCountryCode2["Brb"] = "BRB";
  IsoCountryCode2["Brn"] = "BRN";
  IsoCountryCode2["Btn"] = "BTN";
  IsoCountryCode2["Bvt"] = "BVT";
  IsoCountryCode2["Bwa"] = "BWA";
  IsoCountryCode2["Caf"] = "CAF";
  IsoCountryCode2["Can"] = "CAN";
  IsoCountryCode2["Cck"] = "CCK";
  IsoCountryCode2["Che"] = "CHE";
  IsoCountryCode2["Chl"] = "CHL";
  IsoCountryCode2["Chn"] = "CHN";
  IsoCountryCode2["Civ"] = "CIV";
  IsoCountryCode2["Cmr"] = "CMR";
  IsoCountryCode2["Cod"] = "COD";
  IsoCountryCode2["Cog"] = "COG";
  IsoCountryCode2["Cok"] = "COK";
  IsoCountryCode2["Col"] = "COL";
  IsoCountryCode2["Com"] = "COM";
  IsoCountryCode2["Cpv"] = "CPV";
  IsoCountryCode2["Cri"] = "CRI";
  IsoCountryCode2["Cub"] = "CUB";
  IsoCountryCode2["Cuw"] = "CUW";
  IsoCountryCode2["Cxr"] = "CXR";
  IsoCountryCode2["Cym"] = "CYM";
  IsoCountryCode2["Cyp"] = "CYP";
  IsoCountryCode2["Cze"] = "CZE";
  IsoCountryCode2["Deu"] = "DEU";
  IsoCountryCode2["Dji"] = "DJI";
  IsoCountryCode2["Dma"] = "DMA";
  IsoCountryCode2["Dnk"] = "DNK";
  IsoCountryCode2["Dom"] = "DOM";
  IsoCountryCode2["Dza"] = "DZA";
  IsoCountryCode2["Ecu"] = "ECU";
  IsoCountryCode2["Egy"] = "EGY";
  IsoCountryCode2["Eri"] = "ERI";
  IsoCountryCode2["Esh"] = "ESH";
  IsoCountryCode2["Esp"] = "ESP";
  IsoCountryCode2["Est"] = "EST";
  IsoCountryCode2["Eth"] = "ETH";
  IsoCountryCode2["Fin"] = "FIN";
  IsoCountryCode2["Fji"] = "FJI";
  IsoCountryCode2["Flk"] = "FLK";
  IsoCountryCode2["Fra"] = "FRA";
  IsoCountryCode2["Fro"] = "FRO";
  IsoCountryCode2["Fsm"] = "FSM";
  IsoCountryCode2["Gab"] = "GAB";
  IsoCountryCode2["Gbr"] = "GBR";
  IsoCountryCode2["Geo"] = "GEO";
  IsoCountryCode2["Ggy"] = "GGY";
  IsoCountryCode2["Gha"] = "GHA";
  IsoCountryCode2["Gib"] = "GIB";
  IsoCountryCode2["Gin"] = "GIN";
  IsoCountryCode2["Glp"] = "GLP";
  IsoCountryCode2["Gmb"] = "GMB";
  IsoCountryCode2["Gnb"] = "GNB";
  IsoCountryCode2["Gnq"] = "GNQ";
  IsoCountryCode2["Grc"] = "GRC";
  IsoCountryCode2["Grd"] = "GRD";
  IsoCountryCode2["Grl"] = "GRL";
  IsoCountryCode2["Gtm"] = "GTM";
  IsoCountryCode2["Guf"] = "GUF";
  IsoCountryCode2["Gum"] = "GUM";
  IsoCountryCode2["Guy"] = "GUY";
  IsoCountryCode2["Hkg"] = "HKG";
  IsoCountryCode2["Hmd"] = "HMD";
  IsoCountryCode2["Hnd"] = "HND";
  IsoCountryCode2["Hrv"] = "HRV";
  IsoCountryCode2["Hti"] = "HTI";
  IsoCountryCode2["Hun"] = "HUN";
  IsoCountryCode2["Idn"] = "IDN";
  IsoCountryCode2["Imn"] = "IMN";
  IsoCountryCode2["Ind"] = "IND";
  IsoCountryCode2["Iot"] = "IOT";
  IsoCountryCode2["Irl"] = "IRL";
  IsoCountryCode2["Irn"] = "IRN";
  IsoCountryCode2["Irq"] = "IRQ";
  IsoCountryCode2["Isl"] = "ISL";
  IsoCountryCode2["Isr"] = "ISR";
  IsoCountryCode2["Ita"] = "ITA";
  IsoCountryCode2["Jam"] = "JAM";
  IsoCountryCode2["Jey"] = "JEY";
  IsoCountryCode2["Jor"] = "JOR";
  IsoCountryCode2["Jpn"] = "JPN";
  IsoCountryCode2["Kaz"] = "KAZ";
  IsoCountryCode2["Ken"] = "KEN";
  IsoCountryCode2["Kgz"] = "KGZ";
  IsoCountryCode2["Khm"] = "KHM";
  IsoCountryCode2["Kir"] = "KIR";
  IsoCountryCode2["Kna"] = "KNA";
  IsoCountryCode2["Kor"] = "KOR";
  IsoCountryCode2["Kwt"] = "KWT";
  IsoCountryCode2["Lao"] = "LAO";
  IsoCountryCode2["Lbn"] = "LBN";
  IsoCountryCode2["Lbr"] = "LBR";
  IsoCountryCode2["Lby"] = "LBY";
  IsoCountryCode2["Lca"] = "LCA";
  IsoCountryCode2["Lie"] = "LIE";
  IsoCountryCode2["Lka"] = "LKA";
  IsoCountryCode2["Lso"] = "LSO";
  IsoCountryCode2["Ltu"] = "LTU";
  IsoCountryCode2["Lux"] = "LUX";
  IsoCountryCode2["Lva"] = "LVA";
  IsoCountryCode2["Mac"] = "MAC";
  IsoCountryCode2["Maf"] = "MAF";
  IsoCountryCode2["Mar"] = "MAR";
  IsoCountryCode2["Mco"] = "MCO";
  IsoCountryCode2["Mda"] = "MDA";
  IsoCountryCode2["Mdg"] = "MDG";
  IsoCountryCode2["Mdv"] = "MDV";
  IsoCountryCode2["Mex"] = "MEX";
  IsoCountryCode2["Mhl"] = "MHL";
  IsoCountryCode2["Mkd"] = "MKD";
  IsoCountryCode2["Mli"] = "MLI";
  IsoCountryCode2["Mlt"] = "MLT";
  IsoCountryCode2["Mmr"] = "MMR";
  IsoCountryCode2["Mne"] = "MNE";
  IsoCountryCode2["Mng"] = "MNG";
  IsoCountryCode2["Mnp"] = "MNP";
  IsoCountryCode2["Moz"] = "MOZ";
  IsoCountryCode2["Mrt"] = "MRT";
  IsoCountryCode2["Msr"] = "MSR";
  IsoCountryCode2["Mtq"] = "MTQ";
  IsoCountryCode2["Mus"] = "MUS";
  IsoCountryCode2["Mwi"] = "MWI";
  IsoCountryCode2["Mys"] = "MYS";
  IsoCountryCode2["Myt"] = "MYT";
  IsoCountryCode2["Nam"] = "NAM";
  IsoCountryCode2["Ncl"] = "NCL";
  IsoCountryCode2["Ner"] = "NER";
  IsoCountryCode2["Nfk"] = "NFK";
  IsoCountryCode2["Nga"] = "NGA";
  IsoCountryCode2["Nic"] = "NIC";
  IsoCountryCode2["Niu"] = "NIU";
  IsoCountryCode2["Nld"] = "NLD";
  IsoCountryCode2["Nor"] = "NOR";
  IsoCountryCode2["Npl"] = "NPL";
  IsoCountryCode2["Nru"] = "NRU";
  IsoCountryCode2["Nzl"] = "NZL";
  IsoCountryCode2["Omn"] = "OMN";
  IsoCountryCode2["Pak"] = "PAK";
  IsoCountryCode2["Pan"] = "PAN";
  IsoCountryCode2["Pcn"] = "PCN";
  IsoCountryCode2["Per"] = "PER";
  IsoCountryCode2["Phl"] = "PHL";
  IsoCountryCode2["Plw"] = "PLW";
  IsoCountryCode2["Png"] = "PNG";
  IsoCountryCode2["Pol"] = "POL";
  IsoCountryCode2["Pri"] = "PRI";
  IsoCountryCode2["Prk"] = "PRK";
  IsoCountryCode2["Prt"] = "PRT";
  IsoCountryCode2["Pry"] = "PRY";
  IsoCountryCode2["Pse"] = "PSE";
  IsoCountryCode2["Pyf"] = "PYF";
  IsoCountryCode2["Qat"] = "QAT";
  IsoCountryCode2["Reu"] = "REU";
  IsoCountryCode2["Rou"] = "ROU";
  IsoCountryCode2["Rus"] = "RUS";
  IsoCountryCode2["Rwa"] = "RWA";
  IsoCountryCode2["Sau"] = "SAU";
  IsoCountryCode2["Sdn"] = "SDN";
  IsoCountryCode2["Sen"] = "SEN";
  IsoCountryCode2["Sgp"] = "SGP";
  IsoCountryCode2["Sgs"] = "SGS";
  IsoCountryCode2["Shn"] = "SHN";
  IsoCountryCode2["Sjm"] = "SJM";
  IsoCountryCode2["Slb"] = "SLB";
  IsoCountryCode2["Sle"] = "SLE";
  IsoCountryCode2["Slv"] = "SLV";
  IsoCountryCode2["Smr"] = "SMR";
  IsoCountryCode2["Som"] = "SOM";
  IsoCountryCode2["Spm"] = "SPM";
  IsoCountryCode2["Srb"] = "SRB";
  IsoCountryCode2["Ssd"] = "SSD";
  IsoCountryCode2["Stp"] = "STP";
  IsoCountryCode2["Sur"] = "SUR";
  IsoCountryCode2["Svk"] = "SVK";
  IsoCountryCode2["Svn"] = "SVN";
  IsoCountryCode2["Swe"] = "SWE";
  IsoCountryCode2["Swz"] = "SWZ";
  IsoCountryCode2["Sxm"] = "SXM";
  IsoCountryCode2["Syc"] = "SYC";
  IsoCountryCode2["Syr"] = "SYR";
  IsoCountryCode2["Tca"] = "TCA";
  IsoCountryCode2["Tcd"] = "TCD";
  IsoCountryCode2["Tgo"] = "TGO";
  IsoCountryCode2["Tha"] = "THA";
  IsoCountryCode2["Tjk"] = "TJK";
  IsoCountryCode2["Tkl"] = "TKL";
  IsoCountryCode2["Tkm"] = "TKM";
  IsoCountryCode2["Tls"] = "TLS";
  IsoCountryCode2["Ton"] = "TON";
  IsoCountryCode2["Tto"] = "TTO";
  IsoCountryCode2["Tun"] = "TUN";
  IsoCountryCode2["Tur"] = "TUR";
  IsoCountryCode2["Tuv"] = "TUV";
  IsoCountryCode2["Twn"] = "TWN";
  IsoCountryCode2["Tza"] = "TZA";
  IsoCountryCode2["Uga"] = "UGA";
  IsoCountryCode2["Ukr"] = "UKR";
  IsoCountryCode2["Umi"] = "UMI";
  IsoCountryCode2["Ury"] = "URY";
  IsoCountryCode2["Usa"] = "USA";
  IsoCountryCode2["Uzb"] = "UZB";
  IsoCountryCode2["Vat"] = "VAT";
  IsoCountryCode2["Vct"] = "VCT";
  IsoCountryCode2["Ven"] = "VEN";
  IsoCountryCode2["Vgb"] = "VGB";
  IsoCountryCode2["Vir"] = "VIR";
  IsoCountryCode2["Vnm"] = "VNM";
  IsoCountryCode2["Vut"] = "VUT";
  IsoCountryCode2["Wlf"] = "WLF";
  IsoCountryCode2["Wsm"] = "WSM";
  IsoCountryCode2["Yem"] = "YEM";
  IsoCountryCode2["Zaf"] = "ZAF";
  IsoCountryCode2["Zmb"] = "ZMB";
  IsoCountryCode2["Zwe"] = "ZWE";
  return IsoCountryCode2;
})(IsoCountryCode || {});
var InvitationUserType = /* @__PURE__ */ ((InvitationUserType2) => {
  InvitationUserType2["BillingUser"] = "BILLING_USER";
  InvitationUserType2["ClientUser"] = "CLIENT_USER";
  InvitationUserType2["Internal"] = "INTERNAL";
  InvitationUserType2["OutletManager"] = "OUTLET_MANAGER";
  InvitationUserType2["Partner"] = "PARTNER";
  InvitationUserType2["SuperUser"] = "SUPER_USER";
  return InvitationUserType2;
})(InvitationUserType || {});
var JourneyLeg = /* @__PURE__ */ ((JourneyLeg2) => {
  JourneyLeg2["Arrival"] = "ARRIVAL";
  JourneyLeg2["Departure"] = "DEPARTURE";
  return JourneyLeg2;
})(JourneyLeg || {});
var LastEditedByType = /* @__PURE__ */ ((LastEditedByType2) => {
  LastEditedByType2["Collinson"] = "COLLINSON";
  LastEditedByType2["Partner"] = "PARTNER";
  return LastEditedByType2;
})(LastEditedByType || {});
var LinkedAccountLifecycleStatus = /* @__PURE__ */ ((LinkedAccountLifecycleStatus2) => {
  LinkedAccountLifecycleStatus2["Active"] = "ACTIVE";
  LinkedAccountLifecycleStatus2["Inactive"] = "INACTIVE";
  return LinkedAccountLifecycleStatus2;
})(LinkedAccountLifecycleStatus || {});
var LinkedAccountProvider = /* @__PURE__ */ ((LinkedAccountProvider2) => {
  LinkedAccountProvider2["LoungeKey"] = "LOUNGE_KEY";
  LinkedAccountProvider2["PriorityPass"] = "PRIORITY_PASS";
  LinkedAccountProvider2["PriorityPassPrivate"] = "PRIORITY_PASS_PRIVATE";
  return LinkedAccountProvider2;
})(LinkedAccountProvider || {});
var LinkedAccountStatusUpdatedBy = /* @__PURE__ */ ((LinkedAccountStatusUpdatedBy2) => {
  LinkedAccountStatusUpdatedBy2["Dil"] = "DIL";
  LinkedAccountStatusUpdatedBy2["Npd"] = "NPD";
  LinkedAccountStatusUpdatedBy2["Other"] = "OTHER";
  LinkedAccountStatusUpdatedBy2["Ppbo"] = "PPBO";
  return LinkedAccountStatusUpdatedBy2;
})(LinkedAccountStatusUpdatedBy || {});
var LocaleCode = /* @__PURE__ */ ((LocaleCode2) => {
  LocaleCode2["Ar"] = "ar";
  LocaleCode2["ArSa"] = "ar_SA";
  LocaleCode2["De"] = "de";
  LocaleCode2["DeDe"] = "de_DE";
  LocaleCode2["EnGb"] = "en_GB";
  LocaleCode2["Es"] = "es";
  LocaleCode2["Es_419"] = "es_419";
  LocaleCode2["FiFi"] = "fi_FI";
  LocaleCode2["Fr"] = "fr";
  LocaleCode2["FrCa"] = "fr_CA";
  LocaleCode2["FrFr"] = "fr_FR";
  LocaleCode2["Id"] = "id";
  LocaleCode2["IdId"] = "id_ID";
  LocaleCode2["It"] = "it";
  LocaleCode2["ItIt"] = "it_IT";
  LocaleCode2["Ja"] = "ja";
  LocaleCode2["JaJp"] = "ja_JP";
  LocaleCode2["Ko"] = "ko";
  LocaleCode2["KoKr"] = "ko_KR";
  LocaleCode2["Ms"] = "ms";
  LocaleCode2["MsMy"] = "ms_MY";
  LocaleCode2["Nl"] = "nl";
  LocaleCode2["NlNl"] = "nl_NL";
  LocaleCode2["Pl"] = "pl";
  LocaleCode2["PlPl"] = "pl_PL";
  LocaleCode2["Pt"] = "pt";
  LocaleCode2["PtBr"] = "pt_BR";
  LocaleCode2["PtPt"] = "pt_PT";
  LocaleCode2["Ru"] = "ru";
  LocaleCode2["RuRu"] = "ru_RU";
  LocaleCode2["Th"] = "th";
  LocaleCode2["ThTh"] = "th_TH";
  LocaleCode2["Tr"] = "tr";
  LocaleCode2["TrTr"] = "tr_TR";
  LocaleCode2["Uk"] = "uk";
  LocaleCode2["UkUa"] = "uk_UA";
  LocaleCode2["Vi"] = "vi";
  LocaleCode2["ViVn"] = "vi_VN";
  LocaleCode2["ZhCn"] = "zh_CN";
  LocaleCode2["ZhHant"] = "zh_Hant";
  LocaleCode2["ZhHantHk"] = "zh_Hant_HK";
  LocaleCode2["ZhHantTw"] = "zh_Hant_TW";
  return LocaleCode2;
})(LocaleCode || {});
var LocationType = /* @__PURE__ */ ((LocationType2) => {
  LocationType2["Airport"] = "AIRPORT";
  LocationType2["FerryStation"] = "FERRY_STATION";
  LocationType2["RailwayStation"] = "RAILWAY_STATION";
  return LocationType2;
})(LocationType || {});
var MembershipPlanStatus = /* @__PURE__ */ ((MembershipPlanStatus2) => {
  MembershipPlanStatus2["Active"] = "Active";
  MembershipPlanStatus2["Cancelled"] = "Cancelled";
  MembershipPlanStatus2["Defunct"] = "Defunct";
  MembershipPlanStatus2["Draft"] = "Draft";
  MembershipPlanStatus2["Inactive"] = "Inactive";
  MembershipPlanStatus2["Pipeline"] = "Pipeline";
  return MembershipPlanStatus2;
})(MembershipPlanStatus || {});
var MembershipStatus = /* @__PURE__ */ ((MembershipStatus2) => {
  MembershipStatus2["Active"] = "ACTIVE";
  MembershipStatus2["Blocked"] = "BLOCKED";
  MembershipStatus2["Cancelled"] = "CANCELLED";
  MembershipStatus2["Error"] = "ERROR";
  MembershipStatus2["Inactive"] = "INACTIVE";
  MembershipStatus2["Processing"] = "PROCESSING";
  MembershipStatus2["Verification"] = "VERIFICATION";
  return MembershipStatus2;
})(MembershipStatus || {});
var MobileAppDataStatus = /* @__PURE__ */ ((MobileAppDataStatus2) => {
  MobileAppDataStatus2["Active"] = "ACTIVE";
  MobileAppDataStatus2["Blocked"] = "BLOCKED";
  return MobileAppDataStatus2;
})(MobileAppDataStatus || {});
var OperationType = /* @__PURE__ */ ((OperationType2) => {
  OperationType2["ContactLessAccessKey"] = "ContactLessAccessKey";
  OperationType2["MagneticStripeAccessKey"] = "MagneticStripeAccessKey";
  OperationType2["ManualEntryAccessKey"] = "ManualEntryAccessKey";
  return OperationType2;
})(OperationType || {});
var Origin = /* @__PURE__ */ ((Origin2) => {
  Origin2["Npd"] = "NPD";
  Origin2["Ppbo"] = "PPBO";
  return Origin2;
})(Origin || {});
var OtpRequestStatus = /* @__PURE__ */ ((OtpRequestStatus2) => {
  OtpRequestStatus2["Active"] = "ACTIVE";
  OtpRequestStatus2["Blocked"] = "BLOCKED";
  return OtpRequestStatus2;
})(OtpRequestStatus || {});
var OutletCategory = /* @__PURE__ */ ((OutletCategory2) => {
  OutletCategory2["Eat"] = "EAT";
  OutletCategory2["FastTrack"] = "FAST_TRACK";
  OutletCategory2["Lounge"] = "LOUNGE";
  OutletCategory2["Rail"] = "RAIL";
  OutletCategory2["Refresh"] = "REFRESH";
  OutletCategory2["Rest"] = "REST";
  OutletCategory2["Retail"] = "RETAIL";
  OutletCategory2["Unwind"] = "UNWIND";
  return OutletCategory2;
})(OutletCategory || {});
var OutletDraftWorkflowStage = /* @__PURE__ */ ((OutletDraftWorkflowStage2) => {
  OutletDraftWorkflowStage2["AwaitingReview"] = "AWAITING_REVIEW";
  OutletDraftWorkflowStage2["AwaitingTranslations"] = "AWAITING_TRANSLATIONS";
  OutletDraftWorkflowStage2["Draft"] = "DRAFT";
  OutletDraftWorkflowStage2["Incomplete"] = "INCOMPLETE";
  OutletDraftWorkflowStage2["PartnerAttention"] = "PARTNER_ATTENTION";
  OutletDraftWorkflowStage2["Published"] = "PUBLISHED";
  OutletDraftWorkflowStage2["Reviewed"] = "REVIEWED";
  return OutletDraftWorkflowStage2;
})(OutletDraftWorkflowStage || {});
var OutletLocationDetailsSection = /* @__PURE__ */ ((OutletLocationDetailsSection2) => {
  OutletLocationDetailsSection2["Concourse"] = "CONCOURSE";
  OutletLocationDetailsSection2["DutyFree"] = "DUTY_FREE";
  OutletLocationDetailsSection2["Floor"] = "FLOOR";
  OutletLocationDetailsSection2["FoodCourt"] = "FOOD_COURT";
  OutletLocationDetailsSection2["Gate"] = "GATE";
  OutletLocationDetailsSection2["Level"] = "LEVEL";
  OutletLocationDetailsSection2["Module"] = "MODULE";
  OutletLocationDetailsSection2["PassportControl"] = "PASSPORT_CONTROL";
  OutletLocationDetailsSection2["Pier"] = "PIER";
  OutletLocationDetailsSection2["Satellite"] = "SATELLITE";
  OutletLocationDetailsSection2["Signs"] = "SIGNS";
  OutletLocationDetailsSection2["Zone"] = "ZONE";
  return OutletLocationDetailsSection2;
})(OutletLocationDetailsSection || {});
var OutletOpenStatus = /* @__PURE__ */ ((OutletOpenStatus2) => {
  OutletOpenStatus2["Closed"] = "CLOSED";
  OutletOpenStatus2["Open"] = "OPEN";
  OutletOpenStatus2["Unavailable"] = "UNAVAILABLE";
  return OutletOpenStatus2;
})(OutletOpenStatus || {});
var OutletRegion = /* @__PURE__ */ ((OutletRegion2) => {
  OutletRegion2["Americas"] = "AMERICAS";
  OutletRegion2["Apac"] = "APAC";
  OutletRegion2["Emea"] = "EMEA";
  OutletRegion2["Global"] = "GLOBAL";
  return OutletRegion2;
})(OutletRegion || {});
var OutletSetDataSourceTypes = /* @__PURE__ */ ((OutletSetDataSourceTypes2) => {
  OutletSetDataSourceTypes2["InventorySet"] = "inventorySet";
  OutletSetDataSourceTypes2["LoungeSet"] = "loungeSet";
  return OutletSetDataSourceTypes2;
})(OutletSetDataSourceTypes || {});
var OutletStatus = /* @__PURE__ */ ((OutletStatus2) => {
  OutletStatus2["Active"] = "ACTIVE";
  OutletStatus2["Closed"] = "CLOSED";
  OutletStatus2["Inactive"] = "INACTIVE";
  OutletStatus2["Live"] = "LIVE";
  OutletStatus2["Old"] = "OLD";
  OutletStatus2["Onboarding"] = "ONBOARDING";
  OutletStatus2["StopSale"] = "STOP_SALE";
  return OutletStatus2;
})(OutletStatus || {});
var OutletSubmissionDecision = /* @__PURE__ */ ((OutletSubmissionDecision2) => {
  OutletSubmissionDecision2["Approve"] = "APPROVE";
  OutletSubmissionDecision2["Reject"] = "REJECT";
  return OutletSubmissionDecision2;
})(OutletSubmissionDecision || {});
var OutletVersionStatus = /* @__PURE__ */ ((OutletVersionStatus2) => {
  OutletVersionStatus2["Draft"] = "DRAFT";
  OutletVersionStatus2["Published"] = "PUBLISHED";
  return OutletVersionStatus2;
})(OutletVersionStatus || {});
var OutletWorkflowStage = /* @__PURE__ */ ((OutletWorkflowStage2) => {
  OutletWorkflowStage2["Draft"] = "DRAFT";
  OutletWorkflowStage2["Incomplete"] = "INCOMPLETE";
  OutletWorkflowStage2["Processing"] = "PROCESSING";
  OutletWorkflowStage2["Published"] = "PUBLISHED";
  return OutletWorkflowStage2;
})(OutletWorkflowStage || {});
var OutletWorkflowStatus = /* @__PURE__ */ ((OutletWorkflowStatus2) => {
  OutletWorkflowStatus2["AwaitingReview"] = "AWAITING_REVIEW";
  OutletWorkflowStatus2["AwaitingTranslations"] = "AWAITING_TRANSLATIONS";
  OutletWorkflowStatus2["Draft"] = "DRAFT";
  OutletWorkflowStatus2["Reviewed"] = "REVIEWED";
  return OutletWorkflowStatus2;
})(OutletWorkflowStatus || {});
var PanStatus = /* @__PURE__ */ ((PanStatus2) => {
  PanStatus2["Active"] = "ACTIVE";
  PanStatus2["Blocked"] = "BLOCKED";
  PanStatus2["Freezed"] = "FREEZED";
  PanStatus2["Inactive"] = "INACTIVE";
  PanStatus2["Stolen"] = "STOLEN";
  return PanStatus2;
})(PanStatus || {});
var PanTypes = /* @__PURE__ */ ((PanTypes2) => {
  PanTypes2["Hashed"] = "HASHED";
  PanTypes2["Tokenized"] = "TOKENIZED";
  PanTypes2["Wallet"] = "WALLET";
  return PanTypes2;
})(PanTypes || {});
var PartnerBrandStatus = /* @__PURE__ */ ((PartnerBrandStatus2) => {
  PartnerBrandStatus2["Live"] = "LIVE";
  PartnerBrandStatus2["Old"] = "OLD";
  PartnerBrandStatus2["Onboarding"] = "ONBOARDING";
  PartnerBrandStatus2["RelationshipEnded"] = "RELATIONSHIP_ENDED";
  PartnerBrandStatus2["RelationshipLive"] = "RELATIONSHIP_LIVE";
  return PartnerBrandStatus2;
})(PartnerBrandStatus || {});
var PartnerRoleType = /* @__PURE__ */ ((PartnerRoleType2) => {
  PartnerRoleType2["External"] = "EXTERNAL";
  PartnerRoleType2["Internal"] = "INTERNAL";
  return PartnerRoleType2;
})(PartnerRoleType || {});
var PartnerUserStatus = /* @__PURE__ */ ((PartnerUserStatus2) => {
  PartnerUserStatus2["Active"] = "ACTIVE";
  PartnerUserStatus2["Inactive"] = "INACTIVE";
  PartnerUserStatus2["PendingInvite"] = "PENDING_INVITE";
  return PartnerUserStatus2;
})(PartnerUserStatus || {});
var PartnerUserType = /* @__PURE__ */ ((PartnerUserType2) => {
  PartnerUserType2["External"] = "EXTERNAL";
  PartnerUserType2["Internal"] = "INTERNAL";
  return PartnerUserType2;
})(PartnerUserType || {});
var PassengerType = /* @__PURE__ */ ((PassengerType2) => {
  PassengerType2["Domestic"] = "DOMESTIC";
  PassengerType2["International"] = "INTERNATIONAL";
  PassengerType2["InTransit"] = "IN_TRANSIT";
  PassengerType2["NonSchengen"] = "NON_SCHENGEN";
  PassengerType2["Schengen"] = "SCHENGEN";
  PassengerType2["UsTransborder"] = "US_TRANSBORDER";
  return PassengerType2;
})(PassengerType || {});
var PayByLinkBin = /* @__PURE__ */ ((PayByLinkBin2) => {
  PayByLinkBin2["Closed"] = "Closed";
  PayByLinkBin2["Open"] = "Open";
  return PayByLinkBin2;
})(PayByLinkBin || {});
var PaymentCardBrand = /* @__PURE__ */ ((PaymentCardBrand2) => {
  PaymentCardBrand2["Affirm"] = "AFFIRM";
  PaymentCardBrand2["Airplus"] = "AIRPLUS";
  PaymentCardBrand2["Alia"] = "ALIA";
  PaymentCardBrand2["Aliadebit"] = "ALIADEBIT";
  PaymentCardBrand2["Amex"] = "AMEX";
  PaymentCardBrand2["Applepay"] = "APPLEPAY";
  PaymentCardBrand2["Argencard"] = "ARGENCARD";
  PaymentCardBrand2["Axp"] = "AXP";
  PaymentCardBrand2["Bcmc"] = "BCMC";
  PaymentCardBrand2["Cabal"] = "CABAL";
  PaymentCardBrand2["Cabaldebit"] = "CABALDEBIT";
  PaymentCardBrand2["Carnet"] = "CARNET";
  PaymentCardBrand2["Cartebancaire"] = "CARTEBANCAIRE";
  PaymentCardBrand2["Cartebleue"] = "CARTEBLEUE";
  PaymentCardBrand2["Cashlinkmalta"] = "CASHLINKMALTA";
  PaymentCardBrand2["Cencosud"] = "CENCOSUD";
  PaymentCardBrand2["ClickToPay"] = "CLICK_TO_PAY";
  PaymentCardBrand2["Dankort"] = "DANKORT";
  PaymentCardBrand2["Diners"] = "DINERS";
  PaymentCardBrand2["Discover"] = "DISCOVER";
  PaymentCardBrand2["Elo"] = "ELO";
  PaymentCardBrand2["Facilypay_3X"] = "FACILYPAY_3X";
  PaymentCardBrand2["Facilypay_3Xsansfrais"] = "FACILYPAY_3XSANSFRAIS";
  PaymentCardBrand2["Facilypay_4X"] = "FACILYPAY_4X";
  PaymentCardBrand2["Facilypay_4Xsansfrais"] = "FACILYPAY_4XSANSFRAIS";
  PaymentCardBrand2["Googlepay"] = "GOOGLEPAY";
  PaymentCardBrand2["HebGiftCard"] = "HEB_GIFT_CARD";
  PaymentCardBrand2["Hipercard"] = "HIPERCARD";
  PaymentCardBrand2["Jcb"] = "JCB";
  PaymentCardBrand2["Mada"] = "MADA";
  PaymentCardBrand2["Maestro"] = "MAESTRO";
  PaymentCardBrand2["Master"] = "MASTER";
  PaymentCardBrand2["Mastercard"] = "MASTERCARD";
  PaymentCardBrand2["Masterdebit"] = "MASTERDEBIT";
  PaymentCardBrand2["Meeza"] = "MEEZA";
  PaymentCardBrand2["Mercadolivre"] = "MERCADOLIVRE";
  PaymentCardBrand2["Naranja"] = "NARANJA";
  PaymentCardBrand2["Nativa"] = "NATIVA";
  PaymentCardBrand2["PetcoMastercard"] = "PETCO_MASTERCARD";
  PaymentCardBrand2["PetcoUplcc"] = "PETCO_UPLCC";
  PaymentCardBrand2["RbcPayplan"] = "RBC_PAYPLAN";
  PaymentCardBrand2["Samsungpay"] = "SAMSUNGPAY";
  PaymentCardBrand2["Scheels"] = "SCHEELS";
  PaymentCardBrand2["Servired"] = "SERVIRED";
  PaymentCardBrand2["Sistemaclave"] = "SISTEMACLAVE";
  PaymentCardBrand2["Staples"] = "STAPLES";
  PaymentCardBrand2["Tarjetashopping"] = "TARJETASHOPPING";
  PaymentCardBrand2["Tcard"] = "TCARD";
  PaymentCardBrand2["Tcarddebit"] = "TCARDDEBIT";
  PaymentCardBrand2["TradeUk"] = "TRADE_UK";
  PaymentCardBrand2["Unionpay"] = "UNIONPAY";
  PaymentCardBrand2["UnionpaySms"] = "UNIONPAY_SMS";
  PaymentCardBrand2["Visa"] = "VISA";
  PaymentCardBrand2["Visadebit"] = "VISADEBIT";
  PaymentCardBrand2["Visaelectron"] = "VISAELECTRON";
  PaymentCardBrand2["Vpay"] = "VPAY";
  return PaymentCardBrand2;
})(PaymentCardBrand || {});
var PaymentCustomerStatus = /* @__PURE__ */ ((PaymentCustomerStatus2) => {
  PaymentCustomerStatus2["Existing"] = "EXISTING";
  PaymentCustomerStatus2["New"] = "NEW";
  return PaymentCustomerStatus2;
})(PaymentCustomerStatus || {});
var PaymentMethod = /* @__PURE__ */ ((PaymentMethod2) => {
  PaymentMethod2["ApplePay"] = "APPLE_PAY";
  PaymentMethod2["Card"] = "CARD";
  PaymentMethod2["GooglePay"] = "GOOGLE_PAY";
  return PaymentMethod2;
})(PaymentMethod || {});
var PaymentMethodType = /* @__PURE__ */ ((PaymentMethodType2) => {
  PaymentMethodType2["CardPayment"] = "CARD_PAYMENT";
  PaymentMethodType2["Entitlement"] = "ENTITLEMENT";
  PaymentMethodType2["OnAccount"] = "ON_ACCOUNT";
  return PaymentMethodType2;
})(PaymentMethodType || {});
var PaymentMode = /* @__PURE__ */ ((PaymentMode2) => {
  PaymentMode2["Embedded"] = "EMBEDDED";
  PaymentMode2["Standalone"] = "STANDALONE";
  return PaymentMode2;
})(PaymentMode || {});
var PaymentOption = /* @__PURE__ */ ((PaymentOption2) => {
  PaymentOption2["Charge"] = "Charge";
  PaymentOption2["NoPaymentRequired"] = "NoPaymentRequired";
  PaymentOption2["Refund"] = "Refund";
  return PaymentOption2;
})(PaymentOption || {});
var PaymentProgramme = /* @__PURE__ */ ((PaymentProgramme2) => {
  PaymentProgramme2["LoungeKey"] = "LOUNGE_KEY";
  PaymentProgramme2["LoungePass"] = "LOUNGE_PASS";
  PaymentProgramme2["PpPrivate"] = "PP_PRIVATE";
  PaymentProgramme2["PriorityPass"] = "PRIORITY_PASS";
  return PaymentProgramme2;
})(PaymentProgramme || {});
var PaymentProvider = /* @__PURE__ */ ((PaymentProvider2) => {
  PaymentProvider2["Aci"] = "ACI";
  PaymentProvider2["Cashfree"] = "CASHFREE";
  PaymentProvider2["Stripe"] = "STRIPE";
  return PaymentProvider2;
})(PaymentProvider || {});
var PaymentRefundPriority = /* @__PURE__ */ ((PaymentRefundPriority2) => {
  PaymentRefundPriority2["Instant"] = "INSTANT";
  PaymentRefundPriority2["Standard"] = "STANDARD";
  return PaymentRefundPriority2;
})(PaymentRefundPriority || {});
var PaymentRefundStatusResult = /* @__PURE__ */ ((PaymentRefundStatusResult2) => {
  PaymentRefundStatusResult2["Cancelled"] = "cancelled";
  PaymentRefundStatusResult2["Failed"] = "failed";
  PaymentRefundStatusResult2["Initialized"] = "initialized";
  PaymentRefundStatusResult2["OnHold"] = "on_hold";
  PaymentRefundStatusResult2["Pending"] = "pending";
  PaymentRefundStatusResult2["Succeeded"] = "succeeded";
  return PaymentRefundStatusResult2;
})(PaymentRefundStatusResult || {});
var PaymentRefundType = /* @__PURE__ */ ((PaymentRefundType2) => {
  PaymentRefundType2["Full"] = "FULL";
  PaymentRefundType2["Partial"] = "PARTIAL";
  return PaymentRefundType2;
})(PaymentRefundType || {});
var PaymentSessionSource = /* @__PURE__ */ ((PaymentSessionSource2) => {
  PaymentSessionSource2["BookingApi"] = "BOOKING_API";
  PaymentSessionSource2["Mobile"] = "MOBILE";
  PaymentSessionSource2["Storefront"] = "STOREFRONT";
  return PaymentSessionSource2;
})(PaymentSessionSource || {});
var PaymentStatusResult = /* @__PURE__ */ ((PaymentStatusResult2) => {
  PaymentStatusResult2["Cancelled"] = "CANCELLED";
  PaymentStatusResult2["Error"] = "ERROR";
  PaymentStatusResult2["Initialized"] = "INITIALIZED";
  PaymentStatusResult2["Pending"] = "PENDING";
  PaymentStatusResult2["Rejected"] = "REJECTED";
  PaymentStatusResult2["Reversed"] = "REVERSED";
  PaymentStatusResult2["Success"] = "SUCCESS";
  return PaymentStatusResult2;
})(PaymentStatusResult || {});
var PaymentType = /* @__PURE__ */ ((PaymentType2) => {
  PaymentType2["Capture"] = "CAPTURE";
  PaymentType2["CardCheck"] = "CARD_CHECK";
  PaymentType2["Credit"] = "CREDIT";
  PaymentType2["Debit"] = "DEBIT";
  PaymentType2["Preauthorization"] = "PREAUTHORIZATION";
  PaymentType2["Refund"] = "REFUND";
  PaymentType2["Reversal"] = "REVERSAL";
  return PaymentType2;
})(PaymentType || {});
var PrimaryProductAccessType = /* @__PURE__ */ ((PrimaryProductAccessType2) => {
  PrimaryProductAccessType2["Reservation"] = "RESERVATION";
  PrimaryProductAccessType2["ReservationFeeOnly"] = "RESERVATION_FEE_ONLY";
  PrimaryProductAccessType2["WalkUp"] = "WALK_UP";
  return PrimaryProductAccessType2;
})(PrimaryProductAccessType || {});
var ProductCategory = /* @__PURE__ */ ((ProductCategory2) => {
  ProductCategory2["Eat"] = "EAT";
  ProductCategory2["FastTrack"] = "FAST_TRACK";
  ProductCategory2["Lounge"] = "LOUNGE";
  ProductCategory2["Rail"] = "RAIL";
  ProductCategory2["Refresh"] = "REFRESH";
  ProductCategory2["Rest"] = "REST";
  ProductCategory2["Unwind"] = "UNWIND";
  return ProductCategory2;
})(ProductCategory || {});
var ProductCostType = /* @__PURE__ */ ((ProductCostType2) => {
  ProductCostType2["Flat"] = "FLAT";
  ProductCostType2["Tiered"] = "TIERED";
  return ProductCostType2;
})(ProductCostType || {});
var ProductFamily = /* @__PURE__ */ ((ProductFamily2) => {
  ProductFamily2["Experience"] = "EXPERIENCE";
  return ProductFamily2;
})(ProductFamily || {});
var ProductIdType = /* @__PURE__ */ ((ProductIdType2) => {
  ProductIdType2["Id"] = "Id";
  ProductIdType2["Code"] = "code";
  ProductIdType2["PartnerProductId"] = "partnerProductID";
  ProductIdType2["SalesforceId"] = "salesforceID";
  return ProductIdType2;
})(ProductIdType || {});
var ProductStage = /* @__PURE__ */ ((ProductStage2) => {
  ProductStage2["Closed"] = "CLOSED";
  ProductStage2["Declined"] = "DECLINED";
  ProductStage2["Draft"] = "DRAFT";
  ProductStage2["Live"] = "LIVE";
  ProductStage2["Onboarding"] = "ONBOARDING";
  return ProductStage2;
})(ProductStage || {});
var ProductStatus = /* @__PURE__ */ ((ProductStatus2) => {
  ProductStatus2["Active"] = "ACTIVE";
  ProductStatus2["Inactive"] = "INACTIVE";
  ProductStatus2["Live"] = "LIVE";
  ProductStatus2["Open"] = "OPEN";
  ProductStatus2["StopSale"] = "STOP_SALE";
  return ProductStatus2;
})(ProductStatus || {});
var ProductType = /* @__PURE__ */ ((ProductType2) => {
  ProductType2["Fasttrack"] = "Fasttrack";
  ProductType2["Lounge"] = "Lounge";
  return ProductType2;
})(ProductType || {});
var Programme = /* @__PURE__ */ ((Programme2) => {
  Programme2["LoungeKey"] = "LOUNGE_KEY";
  Programme2["LoungePass"] = "LOUNGE_PASS";
  Programme2["PpPreferred"] = "PP_PREFERRED";
  Programme2["PpPrivate"] = "PP_PRIVATE";
  Programme2["PriorityPass"] = "PRIORITY_PASS";
  return Programme2;
})(Programme || {});
var Proposition = /* @__PURE__ */ ((Proposition2) => {
  Proposition2["Core"] = "Core";
  Proposition2["Passport"] = "Passport";
  Proposition2["Preferred"] = "Preferred";
  return Proposition2;
})(Proposition || {});
var RefundStatus = /* @__PURE__ */ ((RefundStatus2) => {
  RefundStatus2["Canceled"] = "CANCELED";
  RefundStatus2["Failed"] = "FAILED";
  RefundStatus2["NotApplicable"] = "NOT_APPLICABLE";
  RefundStatus2["Pending"] = "PENDING";
  RefundStatus2["RequiresAction"] = "REQUIRES_ACTION";
  RefundStatus2["Succeeded"] = "SUCCEEDED";
  return RefundStatus2;
})(RefundStatus || {});
var RefundStatusReasonCode = /* @__PURE__ */ ((RefundStatusReasonCode2) => {
  RefundStatusReasonCode2["DeclinedByOutletStaff"] = "DECLINED_BY_OUTLET_STAFF";
  RefundStatusReasonCode2["DeclinedByUser"] = "DECLINED_BY_USER";
  RefundStatusReasonCode2["PaymentTimedOut"] = "PAYMENT_TIMED_OUT";
  RefundStatusReasonCode2["RefundBadExperience"] = "REFUND_BAD_EXPERIENCE";
  RefundStatusReasonCode2["RefundLoungeClosed"] = "REFUND_LOUNGE_CLOSED";
  RefundStatusReasonCode2["RefundOther"] = "REFUND_OTHER";
  return RefundStatusReasonCode2;
})(RefundStatusReasonCode || {});
var ReviewLookupType = /* @__PURE__ */ ((ReviewLookupType2) => {
  ReviewLookupType2["BookingId"] = "BOOKING_ID";
  ReviewLookupType2["ConsumerId"] = "CONSUMER_ID";
  ReviewLookupType2["OutletCode"] = "OUTLET_CODE";
  ReviewLookupType2["ReviewId"] = "REVIEW_ID";
  ReviewLookupType2["VisitId"] = "VISIT_ID";
  return ReviewLookupType2;
})(ReviewLookupType || {});
var SearchIsoCountryCode = /* @__PURE__ */ ((SearchIsoCountryCode2) => {
  SearchIsoCountryCode2["Abw"] = "ABW";
  SearchIsoCountryCode2["Afg"] = "AFG";
  SearchIsoCountryCode2["Ago"] = "AGO";
  SearchIsoCountryCode2["Aia"] = "AIA";
  SearchIsoCountryCode2["Ala"] = "ALA";
  SearchIsoCountryCode2["Alb"] = "ALB";
  SearchIsoCountryCode2["And"] = "AND";
  SearchIsoCountryCode2["Ant"] = "ANT";
  SearchIsoCountryCode2["Are"] = "ARE";
  SearchIsoCountryCode2["Arg"] = "ARG";
  SearchIsoCountryCode2["Arm"] = "ARM";
  SearchIsoCountryCode2["Asm"] = "ASM";
  SearchIsoCountryCode2["Ata"] = "ATA";
  SearchIsoCountryCode2["Atf"] = "ATF";
  SearchIsoCountryCode2["Atg"] = "ATG";
  SearchIsoCountryCode2["Aus"] = "AUS";
  SearchIsoCountryCode2["Aut"] = "AUT";
  SearchIsoCountryCode2["Aze"] = "AZE";
  SearchIsoCountryCode2["Bdi"] = "BDI";
  SearchIsoCountryCode2["Bel"] = "BEL";
  SearchIsoCountryCode2["Ben"] = "BEN";
  SearchIsoCountryCode2["Bes"] = "BES";
  SearchIsoCountryCode2["Bfa"] = "BFA";
  SearchIsoCountryCode2["Bgd"] = "BGD";
  SearchIsoCountryCode2["Bgr"] = "BGR";
  SearchIsoCountryCode2["Bhr"] = "BHR";
  SearchIsoCountryCode2["Bhs"] = "BHS";
  SearchIsoCountryCode2["Bih"] = "BIH";
  SearchIsoCountryCode2["Blm"] = "BLM";
  SearchIsoCountryCode2["Blr"] = "BLR";
  SearchIsoCountryCode2["Blz"] = "BLZ";
  SearchIsoCountryCode2["Bmu"] = "BMU";
  SearchIsoCountryCode2["Bol"] = "BOL";
  SearchIsoCountryCode2["Bra"] = "BRA";
  SearchIsoCountryCode2["Brb"] = "BRB";
  SearchIsoCountryCode2["Brn"] = "BRN";
  SearchIsoCountryCode2["Btn"] = "BTN";
  SearchIsoCountryCode2["Bvt"] = "BVT";
  SearchIsoCountryCode2["Bwa"] = "BWA";
  SearchIsoCountryCode2["Caf"] = "CAF";
  SearchIsoCountryCode2["Can"] = "CAN";
  SearchIsoCountryCode2["Cck"] = "CCK";
  SearchIsoCountryCode2["Che"] = "CHE";
  SearchIsoCountryCode2["Chl"] = "CHL";
  SearchIsoCountryCode2["Chn"] = "CHN";
  SearchIsoCountryCode2["Civ"] = "CIV";
  SearchIsoCountryCode2["Cmr"] = "CMR";
  SearchIsoCountryCode2["Cod"] = "COD";
  SearchIsoCountryCode2["Cog"] = "COG";
  SearchIsoCountryCode2["Cok"] = "COK";
  SearchIsoCountryCode2["Col"] = "COL";
  SearchIsoCountryCode2["Com"] = "COM";
  SearchIsoCountryCode2["Cpv"] = "CPV";
  SearchIsoCountryCode2["Cri"] = "CRI";
  SearchIsoCountryCode2["Cub"] = "CUB";
  SearchIsoCountryCode2["Cuw"] = "CUW";
  SearchIsoCountryCode2["Cxr"] = "CXR";
  SearchIsoCountryCode2["Cym"] = "CYM";
  SearchIsoCountryCode2["Cyp"] = "CYP";
  SearchIsoCountryCode2["Cze"] = "CZE";
  SearchIsoCountryCode2["Deu"] = "DEU";
  SearchIsoCountryCode2["Dji"] = "DJI";
  SearchIsoCountryCode2["Dma"] = "DMA";
  SearchIsoCountryCode2["Dnk"] = "DNK";
  SearchIsoCountryCode2["Dom"] = "DOM";
  SearchIsoCountryCode2["Dza"] = "DZA";
  SearchIsoCountryCode2["Ecu"] = "ECU";
  SearchIsoCountryCode2["Egy"] = "EGY";
  SearchIsoCountryCode2["Eri"] = "ERI";
  SearchIsoCountryCode2["Esh"] = "ESH";
  SearchIsoCountryCode2["Esp"] = "ESP";
  SearchIsoCountryCode2["Est"] = "EST";
  SearchIsoCountryCode2["Eth"] = "ETH";
  SearchIsoCountryCode2["Fin"] = "FIN";
  SearchIsoCountryCode2["Fji"] = "FJI";
  SearchIsoCountryCode2["Flk"] = "FLK";
  SearchIsoCountryCode2["Fra"] = "FRA";
  SearchIsoCountryCode2["Fro"] = "FRO";
  SearchIsoCountryCode2["Fsm"] = "FSM";
  SearchIsoCountryCode2["Gab"] = "GAB";
  SearchIsoCountryCode2["Gbr"] = "GBR";
  SearchIsoCountryCode2["Geo"] = "GEO";
  SearchIsoCountryCode2["Ggy"] = "GGY";
  SearchIsoCountryCode2["Gha"] = "GHA";
  SearchIsoCountryCode2["Gib"] = "GIB";
  SearchIsoCountryCode2["Gin"] = "GIN";
  SearchIsoCountryCode2["Glp"] = "GLP";
  SearchIsoCountryCode2["Gmb"] = "GMB";
  SearchIsoCountryCode2["Gnb"] = "GNB";
  SearchIsoCountryCode2["Gnq"] = "GNQ";
  SearchIsoCountryCode2["Grc"] = "GRC";
  SearchIsoCountryCode2["Grd"] = "GRD";
  SearchIsoCountryCode2["Grl"] = "GRL";
  SearchIsoCountryCode2["Gtm"] = "GTM";
  SearchIsoCountryCode2["Guf"] = "GUF";
  SearchIsoCountryCode2["Gum"] = "GUM";
  SearchIsoCountryCode2["Guy"] = "GUY";
  SearchIsoCountryCode2["Hkg"] = "HKG";
  SearchIsoCountryCode2["Hmd"] = "HMD";
  SearchIsoCountryCode2["Hnd"] = "HND";
  SearchIsoCountryCode2["Hrv"] = "HRV";
  SearchIsoCountryCode2["Hti"] = "HTI";
  SearchIsoCountryCode2["Hun"] = "HUN";
  SearchIsoCountryCode2["Idn"] = "IDN";
  SearchIsoCountryCode2["Imn"] = "IMN";
  SearchIsoCountryCode2["Ind"] = "IND";
  SearchIsoCountryCode2["Iot"] = "IOT";
  SearchIsoCountryCode2["Irl"] = "IRL";
  SearchIsoCountryCode2["Irn"] = "IRN";
  SearchIsoCountryCode2["Irq"] = "IRQ";
  SearchIsoCountryCode2["Isl"] = "ISL";
  SearchIsoCountryCode2["Isr"] = "ISR";
  SearchIsoCountryCode2["Ita"] = "ITA";
  SearchIsoCountryCode2["Jam"] = "JAM";
  SearchIsoCountryCode2["Jey"] = "JEY";
  SearchIsoCountryCode2["Jor"] = "JOR";
  SearchIsoCountryCode2["Jpn"] = "JPN";
  SearchIsoCountryCode2["Kaz"] = "KAZ";
  SearchIsoCountryCode2["Ken"] = "KEN";
  SearchIsoCountryCode2["Kgz"] = "KGZ";
  SearchIsoCountryCode2["Khm"] = "KHM";
  SearchIsoCountryCode2["Kir"] = "KIR";
  SearchIsoCountryCode2["Kna"] = "KNA";
  SearchIsoCountryCode2["Kor"] = "KOR";
  SearchIsoCountryCode2["Kwt"] = "KWT";
  SearchIsoCountryCode2["Lao"] = "LAO";
  SearchIsoCountryCode2["Lbn"] = "LBN";
  SearchIsoCountryCode2["Lbr"] = "LBR";
  SearchIsoCountryCode2["Lby"] = "LBY";
  SearchIsoCountryCode2["Lca"] = "LCA";
  SearchIsoCountryCode2["Lie"] = "LIE";
  SearchIsoCountryCode2["Lka"] = "LKA";
  SearchIsoCountryCode2["Lso"] = "LSO";
  SearchIsoCountryCode2["Ltu"] = "LTU";
  SearchIsoCountryCode2["Lux"] = "LUX";
  SearchIsoCountryCode2["Lva"] = "LVA";
  SearchIsoCountryCode2["Mac"] = "MAC";
  SearchIsoCountryCode2["Maf"] = "MAF";
  SearchIsoCountryCode2["Mar"] = "MAR";
  SearchIsoCountryCode2["Mco"] = "MCO";
  SearchIsoCountryCode2["Mda"] = "MDA";
  SearchIsoCountryCode2["Mdg"] = "MDG";
  SearchIsoCountryCode2["Mdv"] = "MDV";
  SearchIsoCountryCode2["Mex"] = "MEX";
  SearchIsoCountryCode2["Mhl"] = "MHL";
  SearchIsoCountryCode2["Mkd"] = "MKD";
  SearchIsoCountryCode2["Mli"] = "MLI";
  SearchIsoCountryCode2["Mlt"] = "MLT";
  SearchIsoCountryCode2["Mmr"] = "MMR";
  SearchIsoCountryCode2["Mne"] = "MNE";
  SearchIsoCountryCode2["Mng"] = "MNG";
  SearchIsoCountryCode2["Mnp"] = "MNP";
  SearchIsoCountryCode2["Moz"] = "MOZ";
  SearchIsoCountryCode2["Mrt"] = "MRT";
  SearchIsoCountryCode2["Msr"] = "MSR";
  SearchIsoCountryCode2["Mtq"] = "MTQ";
  SearchIsoCountryCode2["Mus"] = "MUS";
  SearchIsoCountryCode2["Mwi"] = "MWI";
  SearchIsoCountryCode2["Mys"] = "MYS";
  SearchIsoCountryCode2["Myt"] = "MYT";
  SearchIsoCountryCode2["Nam"] = "NAM";
  SearchIsoCountryCode2["Ncl"] = "NCL";
  SearchIsoCountryCode2["Ner"] = "NER";
  SearchIsoCountryCode2["Nfk"] = "NFK";
  SearchIsoCountryCode2["Nga"] = "NGA";
  SearchIsoCountryCode2["Nic"] = "NIC";
  SearchIsoCountryCode2["Niu"] = "NIU";
  SearchIsoCountryCode2["Nld"] = "NLD";
  SearchIsoCountryCode2["Nor"] = "NOR";
  SearchIsoCountryCode2["Npl"] = "NPL";
  SearchIsoCountryCode2["Nru"] = "NRU";
  SearchIsoCountryCode2["Nzl"] = "NZL";
  SearchIsoCountryCode2["Omn"] = "OMN";
  SearchIsoCountryCode2["Pak"] = "PAK";
  SearchIsoCountryCode2["Pan"] = "PAN";
  SearchIsoCountryCode2["Pcn"] = "PCN";
  SearchIsoCountryCode2["Per"] = "PER";
  SearchIsoCountryCode2["Phl"] = "PHL";
  SearchIsoCountryCode2["Plw"] = "PLW";
  SearchIsoCountryCode2["Png"] = "PNG";
  SearchIsoCountryCode2["Pol"] = "POL";
  SearchIsoCountryCode2["Pri"] = "PRI";
  SearchIsoCountryCode2["Prk"] = "PRK";
  SearchIsoCountryCode2["Prt"] = "PRT";
  SearchIsoCountryCode2["Pry"] = "PRY";
  SearchIsoCountryCode2["Pse"] = "PSE";
  SearchIsoCountryCode2["Pyf"] = "PYF";
  SearchIsoCountryCode2["Qat"] = "QAT";
  SearchIsoCountryCode2["Reu"] = "REU";
  SearchIsoCountryCode2["Rou"] = "ROU";
  SearchIsoCountryCode2["Rus"] = "RUS";
  SearchIsoCountryCode2["Rwa"] = "RWA";
  SearchIsoCountryCode2["Sau"] = "SAU";
  SearchIsoCountryCode2["Sdn"] = "SDN";
  SearchIsoCountryCode2["Sen"] = "SEN";
  SearchIsoCountryCode2["Sgp"] = "SGP";
  SearchIsoCountryCode2["Sgs"] = "SGS";
  SearchIsoCountryCode2["Shn"] = "SHN";
  SearchIsoCountryCode2["Sjm"] = "SJM";
  SearchIsoCountryCode2["Slb"] = "SLB";
  SearchIsoCountryCode2["Sle"] = "SLE";
  SearchIsoCountryCode2["Slv"] = "SLV";
  SearchIsoCountryCode2["Smr"] = "SMR";
  SearchIsoCountryCode2["Som"] = "SOM";
  SearchIsoCountryCode2["Spm"] = "SPM";
  SearchIsoCountryCode2["Srb"] = "SRB";
  SearchIsoCountryCode2["Ssd"] = "SSD";
  SearchIsoCountryCode2["Stp"] = "STP";
  SearchIsoCountryCode2["Sur"] = "SUR";
  SearchIsoCountryCode2["Svk"] = "SVK";
  SearchIsoCountryCode2["Svn"] = "SVN";
  SearchIsoCountryCode2["Swe"] = "SWE";
  SearchIsoCountryCode2["Swz"] = "SWZ";
  SearchIsoCountryCode2["Sxm"] = "SXM";
  SearchIsoCountryCode2["Syc"] = "SYC";
  SearchIsoCountryCode2["Syr"] = "SYR";
  SearchIsoCountryCode2["Tca"] = "TCA";
  SearchIsoCountryCode2["Tcd"] = "TCD";
  SearchIsoCountryCode2["Tgo"] = "TGO";
  SearchIsoCountryCode2["Tha"] = "THA";
  SearchIsoCountryCode2["Tjk"] = "TJK";
  SearchIsoCountryCode2["Tkl"] = "TKL";
  SearchIsoCountryCode2["Tkm"] = "TKM";
  SearchIsoCountryCode2["Tls"] = "TLS";
  SearchIsoCountryCode2["Ton"] = "TON";
  SearchIsoCountryCode2["Tto"] = "TTO";
  SearchIsoCountryCode2["Tun"] = "TUN";
  SearchIsoCountryCode2["Tur"] = "TUR";
  SearchIsoCountryCode2["Tuv"] = "TUV";
  SearchIsoCountryCode2["Twn"] = "TWN";
  SearchIsoCountryCode2["Tza"] = "TZA";
  SearchIsoCountryCode2["Uga"] = "UGA";
  SearchIsoCountryCode2["Ukr"] = "UKR";
  SearchIsoCountryCode2["Umi"] = "UMI";
  SearchIsoCountryCode2["Ury"] = "URY";
  SearchIsoCountryCode2["Usa"] = "USA";
  SearchIsoCountryCode2["Uzb"] = "UZB";
  SearchIsoCountryCode2["Vat"] = "VAT";
  SearchIsoCountryCode2["Vct"] = "VCT";
  SearchIsoCountryCode2["Ven"] = "VEN";
  SearchIsoCountryCode2["Vgb"] = "VGB";
  SearchIsoCountryCode2["Vir"] = "VIR";
  SearchIsoCountryCode2["Vnm"] = "VNM";
  SearchIsoCountryCode2["Vut"] = "VUT";
  SearchIsoCountryCode2["Wlf"] = "WLF";
  SearchIsoCountryCode2["Wsm"] = "WSM";
  SearchIsoCountryCode2["Yem"] = "YEM";
  SearchIsoCountryCode2["Zaf"] = "ZAF";
  SearchIsoCountryCode2["Zmb"] = "ZMB";
  SearchIsoCountryCode2["Zwe"] = "ZWE";
  return SearchIsoCountryCode2;
})(SearchIsoCountryCode || {});
var SearchLocaleCode = /* @__PURE__ */ ((SearchLocaleCode2) => {
  SearchLocaleCode2["Ar"] = "ar";
  SearchLocaleCode2["ArSa"] = "ar_SA";
  SearchLocaleCode2["De"] = "de";
  SearchLocaleCode2["DeDe"] = "de_DE";
  SearchLocaleCode2["EnGb"] = "en_GB";
  SearchLocaleCode2["Es"] = "es";
  SearchLocaleCode2["Es_419"] = "es_419";
  SearchLocaleCode2["FiFi"] = "fi_FI";
  SearchLocaleCode2["Fr"] = "fr";
  SearchLocaleCode2["FrCa"] = "fr_CA";
  SearchLocaleCode2["FrFr"] = "fr_FR";
  SearchLocaleCode2["Id"] = "id";
  SearchLocaleCode2["IdId"] = "id_ID";
  SearchLocaleCode2["It"] = "it";
  SearchLocaleCode2["ItIt"] = "it_IT";
  SearchLocaleCode2["Ja"] = "ja";
  SearchLocaleCode2["JaJp"] = "ja_JP";
  SearchLocaleCode2["Ko"] = "ko";
  SearchLocaleCode2["KoKr"] = "ko_KR";
  SearchLocaleCode2["Ms"] = "ms";
  SearchLocaleCode2["MsMy"] = "ms_MY";
  SearchLocaleCode2["Nl"] = "nl";
  SearchLocaleCode2["NlNl"] = "nl_NL";
  SearchLocaleCode2["Pl"] = "pl";
  SearchLocaleCode2["PlPl"] = "pl_PL";
  SearchLocaleCode2["Pt"] = "pt";
  SearchLocaleCode2["PtBr"] = "pt_BR";
  SearchLocaleCode2["PtPt"] = "pt_PT";
  SearchLocaleCode2["Ru"] = "ru";
  SearchLocaleCode2["RuRu"] = "ru_RU";
  SearchLocaleCode2["Th"] = "th";
  SearchLocaleCode2["ThTh"] = "th_TH";
  SearchLocaleCode2["Tr"] = "tr";
  SearchLocaleCode2["TrTr"] = "tr_TR";
  SearchLocaleCode2["Uk"] = "uk";
  SearchLocaleCode2["UkUa"] = "uk_UA";
  SearchLocaleCode2["Vi"] = "vi";
  SearchLocaleCode2["ViVn"] = "vi_VN";
  SearchLocaleCode2["ZhCn"] = "zh_CN";
  SearchLocaleCode2["ZhHant"] = "zh_Hant";
  SearchLocaleCode2["ZhHantHk"] = "zh_Hant_HK";
  SearchLocaleCode2["ZhHantTw"] = "zh_Hant_TW";
  return SearchLocaleCode2;
})(SearchLocaleCode || {});
var SearchLocationType = /* @__PURE__ */ ((SearchLocationType2) => {
  SearchLocationType2["Airport"] = "AIRPORT";
  SearchLocationType2["FerryStation"] = "FERRY_STATION";
  SearchLocationType2["RailwayStation"] = "RAILWAY_STATION";
  return SearchLocationType2;
})(SearchLocationType || {});
var SearchObjectType = /* @__PURE__ */ ((SearchObjectType2) => {
  SearchObjectType2["LocationProduct"] = "LOCATION_PRODUCT";
  SearchObjectType2["Outlet"] = "OUTLET";
  return SearchObjectType2;
})(SearchObjectType || {});
var SearchOutletCategory = /* @__PURE__ */ ((SearchOutletCategory2) => {
  SearchOutletCategory2["Eat"] = "EAT";
  SearchOutletCategory2["FastTrack"] = "FAST_TRACK";
  SearchOutletCategory2["Lounge"] = "LOUNGE";
  SearchOutletCategory2["Rail"] = "RAIL";
  SearchOutletCategory2["Refresh"] = "REFRESH";
  SearchOutletCategory2["Rest"] = "REST";
  SearchOutletCategory2["Retail"] = "RETAIL";
  SearchOutletCategory2["Unwind"] = "UNWIND";
  return SearchOutletCategory2;
})(SearchOutletCategory || {});
var SearchOutletRegion = /* @__PURE__ */ ((SearchOutletRegion2) => {
  SearchOutletRegion2["Americas"] = "AMERICAS";
  SearchOutletRegion2["Apac"] = "APAC";
  SearchOutletRegion2["Emea"] = "EMEA";
  SearchOutletRegion2["Global"] = "GLOBAL";
  return SearchOutletRegion2;
})(SearchOutletRegion || {});
var SearchPassengerType = /* @__PURE__ */ ((SearchPassengerType2) => {
  SearchPassengerType2["Domestic"] = "DOMESTIC";
  SearchPassengerType2["International"] = "INTERNATIONAL";
  SearchPassengerType2["InTransit"] = "IN_TRANSIT";
  SearchPassengerType2["NonSchengen"] = "NON_SCHENGEN";
  SearchPassengerType2["Schengen"] = "SCHENGEN";
  SearchPassengerType2["UsTransborder"] = "US_TRANSBORDER";
  return SearchPassengerType2;
})(SearchPassengerType || {});
var SearchPrimaryProductAccessType = /* @__PURE__ */ ((SearchPrimaryProductAccessType2) => {
  SearchPrimaryProductAccessType2["Reservation"] = "RESERVATION";
  SearchPrimaryProductAccessType2["ReservationFeeOnly"] = "RESERVATION_FEE_ONLY";
  SearchPrimaryProductAccessType2["WalkUp"] = "WALK_UP";
  return SearchPrimaryProductAccessType2;
})(SearchPrimaryProductAccessType || {});
var SearchProductCategory = /* @__PURE__ */ ((SearchProductCategory2) => {
  SearchProductCategory2["Eat"] = "EAT";
  SearchProductCategory2["FastTrack"] = "FAST_TRACK";
  SearchProductCategory2["Lounge"] = "LOUNGE";
  SearchProductCategory2["Rail"] = "RAIL";
  SearchProductCategory2["Refresh"] = "REFRESH";
  SearchProductCategory2["Rest"] = "REST";
  SearchProductCategory2["Unwind"] = "UNWIND";
  return SearchProductCategory2;
})(SearchProductCategory || {});
var SearchProductStatus = /* @__PURE__ */ ((SearchProductStatus2) => {
  SearchProductStatus2["Active"] = "ACTIVE";
  SearchProductStatus2["Inactive"] = "INACTIVE";
  SearchProductStatus2["Onboarding"] = "ONBOARDING";
  SearchProductStatus2["StopSale"] = "STOP_SALE";
  return SearchProductStatus2;
})(SearchProductStatus || {});
var SearchType = /* @__PURE__ */ ((SearchType2) => {
  SearchType2["Airport"] = "AIRPORT";
  SearchType2["AirportDepDatetime"] = "AIRPORT_DEP_DATETIME";
  SearchType2["Flight"] = "FLIGHT";
  SearchType2["FlightManual"] = "FLIGHT_MANUAL";
  return SearchType2;
})(SearchType || {});
var SlotState = /* @__PURE__ */ ((SlotState2) => {
  SlotState2["Cancelled"] = "CANCELLED";
  SlotState2["Confirmed"] = "CONFIRMED";
  SlotState2["Holding"] = "HOLDING";
  return SlotState2;
})(SlotState || {});
var SmokingPolicy = /* @__PURE__ */ ((SmokingPolicy2) => {
  SmokingPolicy2["SmokingAreaInsideLounge"] = "smokingAreaInsideLounge";
  SmokingPolicy2["SmokingRoomInsideLounge"] = "smokingRoomInsideLounge";
  return SmokingPolicy2;
})(SmokingPolicy || {});
var SortBy = /* @__PURE__ */ ((SortBy2) => {
  SortBy2["CreatedAt"] = "CREATED_AT";
  SortBy2["OverallRating"] = "OVERALL_RATING";
  return SortBy2;
})(SortBy || {});
var SortField = /* @__PURE__ */ ((SortField2) => {
  SortField2["BookedFrom"] = "BOOKED_FROM";
  SortField2["CreatedAt"] = "CREATED_AT";
  return SortField2;
})(SortField || {});
var SortOrder = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["Asc"] = "ASC";
  SortOrder2["Desc"] = "DESC";
  return SortOrder2;
})(SortOrder || {});
var Status = /* @__PURE__ */ ((Status2) => {
  Status2["Active"] = "ACTIVE";
  Status2["Inactive"] = "INACTIVE";
  Status2["StopSale"] = "STOP_SALE";
  return Status2;
})(Status || {});
var StatusReasonCode = /* @__PURE__ */ ((StatusReasonCode2) => {
  StatusReasonCode2["DeclinedByOutletStaff"] = "DECLINED_BY_OUTLET_STAFF";
  StatusReasonCode2["DeclinedByUser"] = "DECLINED_BY_USER";
  StatusReasonCode2["PaymentTimedOut"] = "PAYMENT_TIMED_OUT";
  StatusReasonCode2["PreAuthDeclined"] = "PRE_AUTH_DECLINED";
  StatusReasonCode2["RefundBadExperience"] = "REFUND_BAD_EXPERIENCE";
  StatusReasonCode2["RefundLoungeClosed"] = "REFUND_LOUNGE_CLOSED";
  StatusReasonCode2["RefundOther"] = "REFUND_OTHER";
  return StatusReasonCode2;
})(StatusReasonCode || {});
var StripeUiMode = /* @__PURE__ */ ((StripeUiMode2) => {
  StripeUiMode2["Embedded"] = "embedded";
  StripeUiMode2["Hosted"] = "hosted";
  return StripeUiMode2;
})(StripeUiMode || {});
var Theme = /* @__PURE__ */ ((Theme2) => {
  Theme2["LoungeKey"] = "LOUNGE_KEY";
  Theme2["PriorityPass"] = "PRIORITY_PASS";
  return Theme2;
})(Theme || {});
var Tier = /* @__PURE__ */ ((Tier2) => {
  Tier2["Black"] = "BLACK";
  Tier2["Gold"] = "GOLD";
  Tier2["LowCost"] = "LOW_COST";
  Tier2["Private"] = "PRIVATE";
  return Tier2;
})(Tier || {});
var TierCyclePeriod = /* @__PURE__ */ ((TierCyclePeriod2) => {
  TierCyclePeriod2["Calendar"] = "CALENDAR";
  TierCyclePeriod2["MatchMembership"] = "MATCH_MEMBERSHIP";
  TierCyclePeriod2["Perpetual"] = "PERPETUAL";
  TierCyclePeriod2["TierAnniversary"] = "TIER_ANNIVERSARY";
  return TierCyclePeriod2;
})(TierCyclePeriod || {});
var TierDurationType = /* @__PURE__ */ ((TierDurationType2) => {
  TierDurationType2["Month"] = "MONTH";
  TierDurationType2["Year"] = "YEAR";
  return TierDurationType2;
})(TierDurationType || {});
var TierExpiryAction = /* @__PURE__ */ ((TierExpiryAction2) => {
  TierExpiryAction2["Downgrade"] = "DOWNGRADE";
  TierExpiryAction2["Renew"] = "RENEW";
  TierExpiryAction2["ReturnToBase"] = "RETURN_TO_BASE";
  TierExpiryAction2["Upgrade"] = "UPGRADE";
  return TierExpiryAction2;
})(TierExpiryAction || {});
var TimezoneType = /* @__PURE__ */ ((TimezoneType2) => {
  TimezoneType2["Local"] = "LOCAL";
  TimezoneType2["Utc"] = "UTC";
  return TimezoneType2;
})(TimezoneType || {});
var TransactionInitiator = /* @__PURE__ */ ((TransactionInitiator2) => {
  TransactionInitiator2["Cit"] = "CIT";
  TransactionInitiator2["Mit"] = "MIT";
  return TransactionInitiator2;
})(TransactionInitiator || {});
var TransactionType = /* @__PURE__ */ ((TransactionType2) => {
  TransactionType2["Ecom"] = "ECOM";
  TransactionType2["Moto"] = "MOTO";
  TransactionType2["Preauth"] = "PREAUTH";
  TransactionType2["Recurring"] = "RECURRING";
  return TransactionType2;
})(TransactionType || {});
var TransferMethod = /* @__PURE__ */ ((TransferMethod2) => {
  TransferMethod2["FirstnameLastname"] = "FIRSTNAME_LASTNAME";
  return TransferMethod2;
})(TransferMethod || {});
var TranslationIdType = /* @__PURE__ */ ((TranslationIdType2) => {
  TranslationIdType2["Id"] = "Id";
  TranslationIdType2["TranslationId"] = "translationId";
  return TranslationIdType2;
})(TranslationIdType || {});
var TranslationStatus = /* @__PURE__ */ ((TranslationStatus2) => {
  TranslationStatus2["Completed"] = "COMPLETED";
  TranslationStatus2["Error"] = "ERROR";
  TranslationStatus2["InProgress"] = "IN_PROGRESS";
  TranslationStatus2["Legacy"] = "LEGACY";
  TranslationStatus2["NotRequired"] = "NOT_REQUIRED";
  TranslationStatus2["PendingSubmission"] = "PENDING_SUBMISSION";
  TranslationStatus2["Requested"] = "REQUESTED";
  return TranslationStatus2;
})(TranslationStatus || {});
var TripLegType = /* @__PURE__ */ ((TripLegType2) => {
  TripLegType2["Inbound"] = "INBOUND";
  TripLegType2["Outbound"] = "OUTBOUND";
  return TripLegType2;
})(TripLegType || {});
var TripPurpose = /* @__PURE__ */ ((TripPurpose2) => {
  TripPurpose2["Business"] = "BUSINESS";
  TripPurpose2["Leisure"] = "LEISURE";
  return TripPurpose2;
})(TripPurpose || {});
var TripSource = /* @__PURE__ */ ((TripSource2) => {
  TripSource2["MobileApp"] = "MOBILE_APP";
  return TripSource2;
})(TripSource || {});
var TripState = /* @__PURE__ */ ((TripState2) => {
  TripState2["Completed"] = "COMPLETED";
  TripState2["Deleted"] = "DELETED";
  TripState2["Upcoming"] = "UPCOMING";
  return TripState2;
})(TripState || {});
var TripType = /* @__PURE__ */ ((TripType2) => {
  TripType2["OneWay"] = "ONE_WAY";
  TripType2["Outbound"] = "OUTBOUND";
  TripType2["Return"] = "RETURN";
  return TripType2;
})(TripType || {});
var UserMembershipOrderKey = /* @__PURE__ */ ((UserMembershipOrderKey2) => {
  UserMembershipOrderKey2["ActivationDate"] = "activationDate";
  UserMembershipOrderKey2["Barcode"] = "barcode";
  UserMembershipOrderKey2["CreatedAt"] = "createdAt";
  UserMembershipOrderKey2["EndDate"] = "endDate";
  UserMembershipOrderKey2["ExternalId"] = "externalID";
  UserMembershipOrderKey2["Id"] = "id";
  UserMembershipOrderKey2["InactiveCancelledDate"] = "inactiveCancelledDate";
  UserMembershipOrderKey2["IsSupplementary"] = "isSupplementary";
  UserMembershipOrderKey2["MembershipNumber"] = "membershipNumber";
  UserMembershipOrderKey2["MembershipStatus"] = "membershipStatus";
  UserMembershipOrderKey2["PlanName"] = "planName";
  UserMembershipOrderKey2["PrimaryMembershipNumber"] = "primaryMembershipNumber";
  UserMembershipOrderKey2["UpdatedAt"] = "updatedAt";
  return UserMembershipOrderKey2;
})(UserMembershipOrderKey || {});
var ValuationProgramme = /* @__PURE__ */ ((ValuationProgramme2) => {
  ValuationProgramme2["LoungeKey"] = "LOUNGE_KEY";
  ValuationProgramme2["LoungePass"] = "LOUNGE_PASS";
  ValuationProgramme2["PpPreferred"] = "PP_PREFERRED";
  ValuationProgramme2["PpPrivate"] = "PP_PRIVATE";
  ValuationProgramme2["PriorityPass"] = "PRIORITY_PASS";
  return ValuationProgramme2;
})(ValuationProgramme || {});
var VariationType = /* @__PURE__ */ ((VariationType2) => {
  VariationType2["Annual"] = "ANNUAL";
  VariationType2["DateSpecific"] = "DATE_SPECIFIC";
  return VariationType2;
})(VariationType || {});
var VisitorCategory = /* @__PURE__ */ ((VisitorCategory2) => {
  VisitorCategory2["Guest"] = "GUEST";
  VisitorCategory2["Member"] = "MEMBER";
  return VisitorCategory2;
})(VisitorCategory || {});
var VisitorType = /* @__PURE__ */ ((VisitorType2) => {
  VisitorType2["Adult"] = "ADULT";
  VisitorType2["Child"] = "CHILD";
  VisitorType2["Infant"] = "INFANT";
  return VisitorType2;
})(VisitorType || {});
var OutletIdType = /* @__PURE__ */ ((OutletIdType2) => {
  OutletIdType2["Id"] = "Id";
  OutletIdType2["Code"] = "code";
  OutletIdType2["ExternalApiid"] = "externalAPIID";
  OutletIdType2["LegacyCode"] = "legacyCode";
  OutletIdType2["SalesforceId"] = "salesforceID";
  return OutletIdType2;
})(OutletIdType || {});
var AcceptInvitationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AcceptInvitation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "acceptInvitationInput" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AcceptInvitationInput" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptInvitation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "acceptInvitationInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "acceptInvitationInput" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "expiresAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inviteeEmail" }
                },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var ConfirmAmendmentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "confirmAmendment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "amendmentInput" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AmendmentInput" }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmAmendment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "amendmentInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "amendmentInput" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "price" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentOption" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refundStatus" }
                },
                { kind: "Field", name: { kind: "Name", value: "refundedAt" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var CancelBookingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "cancelBooking" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cancelBookingId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelBooking" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cancelBookingId" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bookedFrom" } },
                { kind: "Field", name: { kind: "Name", value: "bookedTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consumer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "experience" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var CancelPaymentSessionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CancelPaymentSession" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "paymentId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelPaymentSession" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "paymentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "paymentId" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "paymentId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentStatusResult" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var CheckinBookingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CheckinBooking" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "checkinBookingId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "checkinBooking" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "checkinBookingId" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bookedFrom" } },
                { kind: "Field", name: { kind: "Name", value: "bookedTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consumer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var ConfirmBookingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ConfirmBooking" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "confirmBookingId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmBooking" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "confirmBookingId" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bookedFrom" } },
                { kind: "Field", name: { kind: "Name", value: "bookedTo" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consumer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "experience" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var ConfirmPaymentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ConfirmPayment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ConfirmPaymentInput" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmPayment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "paymentId" } },
                { kind: "Field", name: { kind: "Name", value: "redirectUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentMethod" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var CreateBookingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateBooking" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "bookingInput" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "BookingInput" }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createBooking" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "bookingInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "bookingInput" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bookedFrom" } },
                { kind: "Field", name: { kind: "Name", value: "bookedTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consumer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "experience" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "productID" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usedEntitlementsCount" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var CreateTranslationMemoryItemDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateTranslationMemoryItem" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "text" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "originOutletId" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "originSection" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isEnglishOnly" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createTranslationMemoryItem" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "text" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "text" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "originOutletId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "originOutletId" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "originSection" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "originSection" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isEnglishOnly" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "isEnglishOnly" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var DeclineBookingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeclineBooking" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "declineBookingId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "declineBooking" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "declineBookingId" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bookedFrom" } },
                { kind: "Field", name: { kind: "Name", value: "bookedTo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consumer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "experience" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var DeleteBookingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteBooking" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deleteBookingId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteBooking" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deleteBookingId" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bookedTo" } },
                { kind: "Field", name: { kind: "Name", value: "bookedFrom" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consumer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "experience" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var FindOrCreateConsumerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "FindOrCreateConsumer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "consumerInput" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ConsumerInput" }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "findOrCreateConsumer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "consumerInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "consumerInput" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var LinkAccountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LinkAccount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "linkedAccountInput" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "LinkedAccountInput" }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "linkAccount" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "linkedAccountInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "linkedAccountInput" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "externalID" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consumer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fullName" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dateOfBirth" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emailAddress" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "crmId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "linkedAccounts" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "sourceCode" } },
                { kind: "Field", name: { kind: "Name", value: "provider" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "membershipID" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "membershipType" }
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var MakePaymentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MakePayment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "makePaymentInput" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "MakePaymentInput" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "makePayment" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "makePaymentInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "makePaymentInput" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentSessionId" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentServiceProvider" }
                },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tokenExCvvConfig" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tokenExId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "origin" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timestamp" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "authenticationKey" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "token" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardType" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var PublishOutletDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PublishOutlet" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "publishOutletId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lockedVersion" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "publishOutlet" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "publishOutletId" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lockedVersion" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lockedVersion" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var RecordPartnerUserLoginDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RecordPartnerUserLogin" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recordPartnerUserLogin" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "lastLoginAt" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var RevertOutletDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RevertOutlet" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "revertOutletId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lockedVersion" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "revertOutlet" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "revertOutletId" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lockedVersion" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lockedVersion" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var ReviewOutletSubmissionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ReviewOutletSubmission" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "outletId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "decision" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OutletSubmissionDecision" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "rejectionReason" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lockedVersion" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "reviewOutletSubmission" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "outletId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "outletId" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "decision" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "decision" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "rejectionReason" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "rejectionReason" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lockedVersion" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lockedVersion" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var SubmitOutletForApprovalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitOutletForApproval" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "outletId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "lockedVersion" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitOutletForApproval" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "outletId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "outletId" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "lockedVersion" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "lockedVersion" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var SubmitTokenExTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitTokenExToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "submitTokenExTokenInput" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SubmitTokenExTokenInput" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitTokenExToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "submitTokenExTokenInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "submitTokenExTokenInput" }
                }
              }
            ]
          }
        ]
      }
    }
  ]
};
var UpdateCheckoutSessionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateCheckoutSession" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "paymentSessionContextInput" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PaymentSessionContextInput" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCheckoutSession" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "paymentSessionContextInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "paymentSessionContextInput" }
                }
              }
            ]
          }
        ]
      }
    }
  ]
};
var UpdateConsumerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateConsumer" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "consumerInput" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ConsumerInput" }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateConsumer" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "consumerInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "consumerInput" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var UpdateOutletDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateOutlet" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "updateOutletId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "outletInput" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "OutletInput" }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "outletContentInput" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "OutletContentInput" }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateOutlet" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "updateOutletId" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "outletInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "outletInput" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "outletContentInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "outletContentInput" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var ForecastDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Forecast" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "loungeBusynessInput" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "LoungeBusynessInput" }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "forecast" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "loungeBusynessInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "loungeBusynessInput" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "level" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetAvailableSlotsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAvailableSlots" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "data" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AvailabilityInput" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAvailableSlots" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "data" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "data" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "slots" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startDate" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endDate" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxDuration" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "slotConfigurationId" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "partnerMetadata" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetBookingByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetBookingById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "getBookingById" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getBookingByID" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "getBookingById" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "actingAccount" }
                },
                { kind: "Field", name: { kind: "Name", value: "bookedFrom" } },
                { kind: "Field", name: { kind: "Name", value: "bookedTo" } },
                { kind: "Field", name: { kind: "Name", value: "lastArrival" } },
                { kind: "Field", name: { kind: "Name", value: "metadata" } },
                { kind: "Field", name: { kind: "Name", value: "reference" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "price" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "price_currency" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guestAdultCount" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guestChildrenCount" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guestInfantCount" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "partnerMetadata" }
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consumer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emailAddress" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fullName" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "experience" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "loungeName" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "openingHours" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "images" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "altText" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "contentType" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "height" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "width" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "airportName" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "terminal" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pricing" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "currency" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "reservationOnlyFee"
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reservationCost" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refundStatus" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "usedEntitlementsCount" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "entitlements" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expiryDate" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expired" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "redeemed" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "refunded" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isUnlimited" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetBookingsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetBookings" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "BookingStatus" }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "experienceId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getBookings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "status" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "experienceID" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "experienceId" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bookedFrom" } },
                { kind: "Field", name: { kind: "Name", value: "bookedTo" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "metadata" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "reference" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guestAdultCount" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guestChildrenCount" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "guestInfantCount" }
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consumer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "emailAddress" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fullName" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "experience" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "loungeName" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetBookingsOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetBookingsOverview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "BookingStatus" }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "experienceId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getBookings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "status" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "experienceID" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "experienceId" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "bookedFrom" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetConsumerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetConsumer" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getConsumer" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "crmId" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "emailAddress" }
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetConsumerByEmailAddressDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetConsumerByEmailAddress" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "emailAddress" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getConsumerByEmailAddress" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "emailAddress" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "emailAddress" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetConsumerByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetConsumerByID" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "getConsumerById" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getConsumerByID" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "getConsumerById" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "linkedAccounts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "membershipID" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "membershipType" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "analytics" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "externalID" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "memberships" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "membershipNumber" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceCode" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "memberships" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "membershipNumber" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "dateOfBirth" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "emailAddress" }
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "locale" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetEntitlementsForProductDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEntitlementsForProduct" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "productId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "bookingEnd" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "bookingStart" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Date" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "consumerId" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "membershipID" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "retry" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getEntitlementsForProduct" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "productId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "productId" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "bookingEnd" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "bookingEnd" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "bookingStart" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "bookingStart" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "membershipID" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "membershipID" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "consumerId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "consumerId" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "retry" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "retry" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "expiryDate" } },
                { kind: "Field", name: { kind: "Name", value: "expired" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "redeemed" } },
                { kind: "Field", name: { kind: "Name", value: "isUnlimited" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetExperienceByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetExperienceByID" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "getExperienceById" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getExperienceByID" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "getExperienceById" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "loungeName" } },
                { kind: "Field", name: { kind: "Name", value: "loungeCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "airportName" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "airportCode" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "terminal" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "terminalCode" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "region" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isoCountryCode" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lbCountryCode" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetFlightDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFlightDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "flightDetails" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "FlightDetailsInput" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getFlightDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "flightDetails" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "flightDetails" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "arrival" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "airport" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "terminal" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dateTime" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "local" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "utc" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "departure" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "airport" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "terminal" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dateTime" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "local" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "utc" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetInvitationByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetInvitationByID" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "getInvitationById" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getInvitationByID" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "getInvitationById" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inviteeEmail" }
                },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetLocationDescriptionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLocationDescription" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationDetails" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OutletLocationDetailsInput" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isLandside" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getLocationDescription" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationDetails" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationDetails" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isLandside" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "isLandside" }
                }
              }
            ]
          }
        ]
      }
    }
  ]
};
var GetOutletDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOutlet" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "getOutletId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "outletIdType" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "outletIDType" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "additionalFilters" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ProductFilters" }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOutlet" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "outletIDType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "outletIdType" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "additionalFilters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "additionalFilters" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "getOutletId" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "maxGuests" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxStayHours" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activationDate" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "permanentClosureDate" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "managedChoicesOrdering" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locationDetails" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "additionalDescription" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessTimes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "text" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "conditions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "text" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "importantInformation" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "text" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "text" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "draft" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "activationDate" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "permanentClosureDate" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "managedChoicesOrdering" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "locationDetails" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "additionalDescription" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "accessTimes" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "text" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "conditions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "text" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "importantInformation"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "text" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "text" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessTimes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "accessHours" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "monday" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "endTime"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "startTime"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "tuesday" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "endTime"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "startTime"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "wednesday" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "endTime"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "startTime"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "thursday" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "endTime"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "startTime"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "friday" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "endTime"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "startTime"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "saturday" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "endTime"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "startTime"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "sunday" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "endTime"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "startTime"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "exceptions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "accessHours"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "startTime"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "endTime"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "date" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startDate" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "endDate" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "exceptionType"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "isOpen" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "priority" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isRecurring"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "peakHours" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startTime" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "endTime" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "conditions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "allowedSmokingPolicy"
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "childrenAdmittedFreeNumber"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "maximum" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "per" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "childrenAdmittedFreeAge"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "from" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "to" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "childrenAllowed" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "childrenMustBeAccompaniedUnderAge"
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "dressCodeOptions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "noAboveKneeSkirtsOrDresses"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "noBaseballCaps"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "noSandals" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "noShorts" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "noSleevelessTops"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "noSportswear"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "noTShirts" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "smartCasual"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hasDressCode" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "minimumChildAge" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "smokingAllowed" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "display" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "conditions" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "locationDetails" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "importantInformation"
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "additionalAccessTimes"
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "additionalConditions"
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "additionalLocationDetails"
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isAvailable" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "details" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "ageLimit" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "complimentaryDrinks"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "complimentaryAlcoholicDrinks"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "extraPaymentRequired"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "preBookingRequired"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "runwayViewFromAllSeats"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "digitalFormatMagazines"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "paperFormatMagazines"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "pointOfInterestID"
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "country" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isoCountryCode" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "landside" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "latitude" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "longitude" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "terminal" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "timezone" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locationDetails" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "outletZone" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "passportControl" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gateNumber" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gateNumberTwo" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "gateLocationDirection"
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "concourse" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "letterOrNumber"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "directions" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeStairs"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeLift"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeEscalator"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeBus"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeShuttle"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeTrain"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "floor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "letterOrNumber"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "directions" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeStairs"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeLift"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeEscalator"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeBus"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeShuttle"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeTrain"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "level" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "letterOrNumber"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "directions" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeStairs"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeLift"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeEscalator"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeBus"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeShuttle"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "takeTrain"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pier" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "letterOrNumber"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "satellite" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "letterOrNumber"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zone" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "letterOrNumber"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "module" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "letterOrNumber"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "dutyFreeDirection"
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "foodCourtDirection"
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "foodCourtName" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hasSignName" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "signName" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "media" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mainImage" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "asset" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "contentType"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "fileName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "height"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "url" }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "width"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "metadata" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lastEdited"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "editor"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "firstName"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "lastName"
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "images" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "asset" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "contentType"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "fileName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "height"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "url" }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "width"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "metadata" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lastEdited"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "editor"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "firstName"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "lastName"
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "meta" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "editor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "organisation"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastEdited" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edited" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "products" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "accessType" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "category" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "costs" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "cost" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "costCurrency"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "defaultTaxPercentage"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "programme" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "projectedCost"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "reservationCost"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "type" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ppStripeID" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "salePrices" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "programme" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "salePrice" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "salePriceCurrency"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "stripePriceID"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "salesforceID" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stage" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tier" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sectionsMeta" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "accessTimes" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "editor" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "firstName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lastName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "organisation"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastEdited" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "lastEditedByType"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edited" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isIncomplete"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "importantInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "editor" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "firstName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lastName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "organisation"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastEdited" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "lastEditedByType"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edited" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isIncomplete"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "conditions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "editor" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "firstName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lastName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "organisation"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastEdited" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "lastEditedByType"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edited" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isIncomplete"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "facilities" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "editor" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "firstName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lastName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "organisation"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastEdited" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "lastEditedByType"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edited" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isIncomplete"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "editor" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "firstName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lastName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "organisation"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastEdited" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "lastEditedByType"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edited" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isIncomplete"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "media" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "editor" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "firstName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lastName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "organisation"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastEdited" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "lastEditedByType"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edited" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isIncomplete"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "editedSections" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "versionStatus" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "workflow" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "submittedAt" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rejectionReason" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "salesforceID" }
                },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "passengerTypes" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "partnerBrand" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "partnerIntegrationData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "partnerIntegrationID"
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "facilities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isAvailable" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "details" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ageLimit" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "complimentaryDrinks"
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "complimentaryAlcoholicDrinks"
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "extraPaymentRequired"
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "preBookingRequired"
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "runwayViewFromAllSeats"
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "digitalFormatMagazines"
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "paperFormatMagazines"
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "legacyFacilities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isAvailable" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timezone" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isoCountryCode" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "landside" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "latitude" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "longitude" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "terminal" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "meta" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "editor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "organisation"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastEdited" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locationDetails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "outletZone" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "passportControl" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gateNumber" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gateNumberTwo" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gateLocationDirection" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "concourse" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "letterOrNumber" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "directions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "takeStairs" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "takeLift" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "takeEscalator"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "takeBus" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "takeShuttle"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "takeTrain" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "floor" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "letterOrNumber" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "directions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "takeStairs" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "takeLift" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "takeEscalator"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "takeBus" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "takeShuttle"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "takeTrain" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "level" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "letterOrNumber" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "directions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "takeStairs" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "takeLift" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "takeEscalator"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "takeBus" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "takeShuttle"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "takeTrain" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pier" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "letterOrNumber" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "satellite" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "letterOrNumber" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "zone" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "letterOrNumber" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "module" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "letterOrNumber" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dutyFreeDirection" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "foodCourtDirection" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "foodCourtName" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasSignName" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "signName" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meta" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "editor" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "organisation" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastEdited" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edited" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workflowStage" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ancillaryProducts" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "tier" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "costs" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cost" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "costCurrency" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "programme" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "defaultTaxPercentage"
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "projectedCost" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reservationCost" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salePrices" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "programme" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "salePrice" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "salePriceCurrency"
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stripePriceID" }
                            }
                          ]
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salesforceID" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "products" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "tier" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "costs" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "cost" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "costCurrency" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "programme" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "defaultTaxPercentage"
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "projectedCost" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "reservationCost" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "partnerIntegrationData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "partnerProductID" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salePrices" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "programme" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "salePrice" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "salePriceCurrency"
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stripePriceID" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessType" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salesforceID" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "stage" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "editedSections" }
                },
                { kind: "Field", name: { kind: "Name", value: "tier" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "conditions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowedSmokingPolicy" }
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "childrenAdmittedFreeNumber"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "maximum" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "per" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "childrenAdmittedFreeAge"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "from" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "to" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "childrenAllowed" }
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "childrenMustBeAccompaniedUnderAge"
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dressCodeOptions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "noAboveKneeSkirtsOrDresses"
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "noBaseballCaps" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "noSandals" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "noShorts" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "noSleevelessTops" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "noSportswear" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "noTShirts" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "smartCasual" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasDressCode" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minimumChildAge" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "smokingAllowed" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "display" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "conditions" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locationDetails" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "importantInformation" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "additionalAccessTimes" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "additionalConditions" }
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "additionalLocationDetails"
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "accessTimes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessHours" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "monday" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startTime" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "endTime" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tuesday" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startTime" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "endTime" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "wednesday" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startTime" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "endTime" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thursday" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startTime" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "endTime" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "friday" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startTime" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "endTime" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "saturday" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startTime" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "endTime" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sunday" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startTime" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "endTime" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "peakHours" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startTime" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endTime" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "description" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "exceptions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "accessHours" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "startTime" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "endTime" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "startDate" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "endDate" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "date" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "exceptionType" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isOpen" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "priority" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isRecurring" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "media" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mainImage" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "asset" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "contentType"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "fileName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "metadata" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastEdited" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "editor" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "firstName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lastName"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "images" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "asset" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "contentType"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "fileName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "height" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "title" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "width" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "metadata" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastEdited" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "editor" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "firstName"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lastName"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "salesforceID" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationEmail" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reservationEmails" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "partnerBrand" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "sectionsMeta" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "editor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "organisation"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastEdited" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastEditedByType" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edited" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isIncomplete" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "media" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "editor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "organisation"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastEdited" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastEditedByType" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edited" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isIncomplete" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessTimes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "editor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "organisation"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastEdited" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastEditedByType" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edited" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isIncomplete" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "conditions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "editor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "organisation"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastEdited" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastEditedByType" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edited" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isIncomplete" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "importantInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "editor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "organisation"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastEdited" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastEditedByType" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edited" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isIncomplete" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "facilities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "editor" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastName" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "organisation"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastEdited" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastEditedByType" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "edited" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isIncomplete" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "workflowStage" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lockedVersion" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetOutletLocationDetailsGroupsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOutletLocationDetailsGroups" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "locationDetails" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OutletLocationDetailsInput" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "isLandside" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "sortOrder" }
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OutletLocationDetailsSection" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOutletLocationDetailsGroups" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "locationDetails" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "locationDetails" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "isLandside" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "isLandside" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "sortOrder" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "sortOrder" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "section" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "locationDetails" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetOutletsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOutlets" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "OutletAndProductFilters" }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOutlets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "page" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "page" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pageSize" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pageSize" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "draft" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "workflow" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "rejectionReason"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "media" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "mainImage" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "asset"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "description"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "title"
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "images" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "asset"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "url"
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "sectionsMeta" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "accessTimes"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "isIncomplete"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "conditions" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "isIncomplete"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "facilities" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "isIncomplete"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "importantInfo"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "isIncomplete"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "location" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "isIncomplete"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "media" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "isIncomplete"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "terminal" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "partnerBrand" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "media" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mainImage" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "asset" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "url" }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "images" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "asset" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "contentType"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "url" }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "workflowStage" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sectionsMeta" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "accessTimes" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isIncomplete"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "conditions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isIncomplete"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "facilities" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isIncomplete"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "importantInfo" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isIncomplete"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isIncomplete"
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "media" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isIncomplete"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentPage" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasNextPage" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasPreviousPage" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPages" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalItemCount" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetOutletsCountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOutletsCount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "OutletAndProductFilters" }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOutlets" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalItemCount" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetPartnerBrandByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPartnerBrandByID" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "OutletAndProductFilters" }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPartnerBrandByID" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "outlets" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "terminal" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "city" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "media" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mainImage" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "asset" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "url" }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "metadata" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lastEdited"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "editor"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "firstName"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "lastName"
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "images" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "asset" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "url" }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "description"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "title"
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "metadata" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lastEdited"
                                          }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "editor"
                                          },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "firstName"
                                                }
                                              },
                                              {
                                                kind: "Field",
                                                name: {
                                                  kind: "Name",
                                                  value: "lastName"
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "workflowStage" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetPartnerBrandsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPartnerBrands" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PartnerBrandFilters" }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPartnerBrands" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "page" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "page" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pageSize" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pageSize" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "items" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "outlets" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentPage" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasNextPage" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasPreviousPage" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalPages" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalItemCount" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetPartnerBrandsCountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPartnerBrandsCount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PartnerBrandFilters" }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPartnerBrands" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalItemCount" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetPartnerByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPartnerByID" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "getPartnerById" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPartnerByID" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "getPartnerById" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "fullName" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "emailAddress" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetPaymentCardsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaymentCards" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "paymentProvider" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "PaymentProvider" }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "membershipId" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaymentCards" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "paymentProvider" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "paymentProvider" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "membershipId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "membershipId" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "brand" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "expiryMonth" } },
                { kind: "Field", name: { kind: "Name", value: "expiryYear" } },
                { kind: "Field", name: { kind: "Name", value: "last4Digits" } },
                { kind: "Field", name: { kind: "Name", value: "isDefault" } },
                { kind: "Field", name: { kind: "Name", value: "isTokenEx" } },
                { kind: "Field", name: { kind: "Name", value: "saved" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pspCardReferenceId" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentServiceProvider" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "company" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "line1" } },
                      { kind: "Field", name: { kind: "Name", value: "line2" } },
                      { kind: "Field", name: { kind: "Name", value: "town" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "county" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postcode" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetPaymentSessionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaymentSession" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "paymentSessionContext" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PaymentSessionContextInput" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "membershipId" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaymentSession" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "paymentSessionContext" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "paymentSessionContext" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "membershipId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "membershipId" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "entityId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentSessionId" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentServiceProvider" }
                },
                { kind: "Field", name: { kind: "Name", value: "dealId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tokenExCvvConfig" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tokenExId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "origin" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timestamp" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "authenticationKey" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "token" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardType" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetPaymentStatusDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetPaymentStatus" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "paymentId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getPaymentStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "paymentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "paymentId" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "value" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "transactionType" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetProductByCodeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetProductByCode" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "filters" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ProductFilters" }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getProductByCode" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "code" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "filters" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "costs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "cost" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "costCurrency" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "defaultTaxPercentage" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "programme" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "projectedCost" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservationCost" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "salePrices" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "programme" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salePrice" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "salePriceCurrency" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stripePriceID" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "salesforceID" }
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "tier" } },
                { kind: "Field", name: { kind: "Name", value: "accessType" } },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "landside" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isoCountryCode" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "terminal" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "partnerBrand" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "stage" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "outlet" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "partnerIntegrationData" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessPeriod" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "agreedPrebookHoldTime" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amendPeriodAllowed" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bookingFlowType" }
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "bookingMaxPeriodAllowed"
                        }
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "bookingMinPeriodAllowed"
                        }
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "cancellationPeriodAllowed"
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxGuests" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "adult" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isChargeable"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isPartySizeImpacted"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "children" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isChargeable"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isPartySizeImpacted"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "infant" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isChargeable"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isPartySizeImpacted"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "partySize" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "senior" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isChargeable"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isPartySizeImpacted"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "value" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "partnerIntegrationID" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "partnerProductID" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pdfGuideUrl" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stripeProductID" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timeSlotPeriod" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var ProductValuationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProductValuation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "valuationInput" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ProductValuationInput" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getProductValuation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "valuationInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "valuationInput" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "consumerID" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "entitlements" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expiryDate" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expired" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "redeemed" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isUnlimited" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "membershipID" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priceDetails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "finalPrice" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "taxAmount" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isTaxInclusive" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priceZone" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "guestPrices" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "memberPrice" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "coveredByEntitlement" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "chargeOwnerTaxDetails" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "chargeOwner" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "collinsonBillingLegalEntity"
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isTaxExempt" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "taxDecisionCode" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "taxesApplied" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "taxCode" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "taxRate" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "taxType" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priceBreakdown" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "consumerPrice" }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "consumerPriceDetails"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "currency" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "gross" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isTaxInclusive"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "net" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "priceZone" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "taxAmount" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "clientPriceDetails"
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "currency" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "gross" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "isTaxInclusive"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "net" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "priceZone" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "taxAmount" }
                                  }
                                ]
                              }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "visitorData" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "isGuest" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "visitorType"
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var SearchExperiencesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchExperiences" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchFilter" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "SearchFilterInput" }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "searchExperiences" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilter" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "searchFilter" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "loungeName" } },
                { kind: "Field", name: { kind: "Name", value: "loungeCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "location" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "airportName" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "airportCode" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "city" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "terminal" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timezone" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "partnerIdProd" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "partnerIdTest" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "partnerIntegrationId" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pricing" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pricingType" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservationCost" }
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lifestyleXReservationCharge"
                        }
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "walkInCostCurrentPPRate"
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lifestyleXWalkInCharge" }
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "lifestyleXReservationCharge"
                        }
                      },
                      { kind: "Field", name: { kind: "Name", value: "vat" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservationOnlyFeeCost" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reservationOnlyFee" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "facilities" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "openingHours" }
                },
                { kind: "Field", name: { kind: "Name", value: "conditions" } },
                { kind: "Field", name: { kind: "Name", value: "directions" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "images" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "altText" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "height" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "width" } },
                      { kind: "Field", name: { kind: "Name", value: "id" } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetTokenExCvvConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTokenExCvvConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cardId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "paymentId" }
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "accessCode" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTokenExCvvConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cardId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cardId" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "paymentId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "paymentId" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "accessCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "accessCode" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "tokenExId" } },
                { kind: "Field", name: { kind: "Name", value: "origin" } },
                { kind: "Field", name: { kind: "Name", value: "timestamp" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "authenticationKey" }
                },
                { kind: "Field", name: { kind: "Name", value: "token" } },
                { kind: "Field", name: { kind: "Name", value: "cardType" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetTranslationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTranslations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" }
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "TranslationStatus" }
              }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTranslations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "status" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "page" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "page" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pageSize" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pageSize" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "translationStatus" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requestedBy" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requestedAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "translationId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "originOutletId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "originSection" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "outletSummary" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "code" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "location" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "city" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "country" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "terminal" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "translations" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ar" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "de" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "en_GB" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "es" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fr" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "it" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ja" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ko" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ms" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "nl" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pl" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "pt" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ru" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "th" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "tr" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uk" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "vi" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zh_CN" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "zh_Hant_HK" }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetTranslationsCountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTranslationsCount" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "status" }
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "TranslationStatus" }
              }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getTranslations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "status" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "status" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetUsersForPartnerDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUsersForPartner" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUsersForPartner" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "page" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "page" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pageSize" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pageSize" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastLoginAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "partnerBrandIds" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customPermissions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "action" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "resource" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "permissions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "resource" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "action" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var GetValidInvitationFromTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetValidInvitationFromToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inviteToken" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getValidInvitationFromToken" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "inviteToken" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inviteToken" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "isValid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "invitation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "inviteeEmail" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "outletIDs" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "partnerId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "expiresAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var IsInvitationTokenValidDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "IsInvitationTokenValid" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inviteToken" }
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "isInvitationTokenValid" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "inviteToken" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inviteToken" }
                }
              }
            ]
          }
        ]
      }
    }
  ]
};
var GetMeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMe" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "me" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userType" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "roles" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isSystem" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "permissions" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" }
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "description"
                                    }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "resource" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "action" }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "customPermissions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "description" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "resource" }
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "action" }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "outletScope" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "partnerBrandIds" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastLoginAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "resolvedPermissions" }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var SearchAirportsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchAirports" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "airportQuery" }
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "AirportSearchInput" }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "searchAirports" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "airportQuery" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "airportQuery" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "iata" } },
                { kind: "Field", name: { kind: "Name", value: "city" } },
                { kind: "Field", name: { kind: "Name", value: "country" } },
                { kind: "Field", name: { kind: "Name", value: "lat" } },
                { kind: "Field", name: { kind: "Name", value: "lng" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "geoloc" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "lat" } },
                      { kind: "Field", name: { kind: "Name", value: "lng" } }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "outletCategories" }
                },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isServiceable" }
                },
                { kind: "Field", name: { kind: "Name", value: "terminals" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var SearchCatalogueDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchCatalogue" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "searchFilters" }
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SearchFilterInput" }
            }
          }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "outletIds" }
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "String" }
              }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "searchCatalogue" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "searchFilters" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "searchFilters" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "outletIds" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "outletIds" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "SearchCatalogueList" }
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "items" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "SearchOutlet" }
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "name" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "code" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "legacyCode" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "status" }
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "location" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "city" }
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "name" }
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "terminal"
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
var SearchTranslationMemoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SearchTranslationMemory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "query" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } }
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "page" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "pageSize" }
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } }
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "requiredLocales" }
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "searchTranslationMemory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "query" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "query" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "page" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "page" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "pageSize" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "pageSize" }
                }
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "requiredLocales" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "requiredLocales" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "text" } }
              ]
            }
          }
        ]
      }
    }
  ]
};
var VerifyPaymentWebAppDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "VerifyPaymentWebApp" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "url" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" }
            }
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "verifyPaymentWebApp" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "url" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "url" }
                }
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "accessCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ui" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locale" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "mode" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "paymentMethods" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "theme" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "successUrl" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "errorUrl" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowedBins" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "declinedBins" }
                      }
                    ]
                  }
                },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "error" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isRetryable" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consumer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "phoneNumber" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "givenName" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "familyName" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentServiceProvider" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "paymentStatusResult" }
                },
                { kind: "Field", name: { kind: "Name", value: "paymentType" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "preAuthCardId" }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "membershipId" }
                },
                { kind: "Field", name: { kind: "Name", value: "dealId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "amount" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currency" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "transactionType" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tokenExIframeConfig" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tokenExId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "origin" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timestamp" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "authenticationKey" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tokenScheme" }
                      }
                    ]
                  }
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tokenExCvvConfig" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tokenExId" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "origin" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timestamp" }
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "authenticationKey" }
                      },
                      { kind: "Field", name: { kind: "Name", value: "token" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cardType" }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AcceptInvitationDocument,
  ActivationStatus,
  AddressType,
  AdmissionPer,
  AffiliateProgramme,
  AmendmentStatus,
  BookingFlowType,
  BookingStatus,
  BookingType,
  BulkImportTranslationMemoryClassification,
  BusinessUnit,
  Businessunit,
  CalculationStatus,
  CancelBookingDocument,
  CancelPaymentSessionDocument,
  CatalogueDataOrigin,
  CatalogueLocale,
  CatalogueLocationType,
  CatalogueProductType,
  CatalogueProgramme,
  ChangeReason,
  ChargeOwner,
  ChatbotParticipantRole,
  CheckinBookingDocument,
  ConfirmAmendmentDocument,
  ConfirmBookingDocument,
  ConfirmPaymentDocument,
  ConsumerCostZone,
  ConsumerLocationType,
  ConsumerOutletRegion,
  ConsumerPassengerType,
  ConsumerPrimaryProductAccessType,
  ConsumerProductCategory,
  ConsumerProgramme,
  ConsumerTier,
  CostZone,
  CreateBookingDocument,
  CreateTranslationMemoryItemDocument,
  Currency,
  DealIneligibilityReason,
  DeclineBookingDocument,
  DeleteBookingDocument,
  EnrollmentStatus,
  EntitlementIsoCountryCode,
  EntitlementLevel,
  EntitlementLocationType,
  EntitlementOutletRegion,
  EntitlementPassengerType,
  EntitlementProductAccessType,
  EntitlementProductCategory,
  EntitlementProgramme,
  EntitlementSelectionMode,
  EntitlementStatus,
  ExceptionType,
  ExperienceCategory,
  ExperienceType,
  FakeDoorInterest,
  FakeDoorOs,
  FakeDoorType,
  FavouriteEntityType,
  FindOrCreateConsumerDocument,
  ForecastDocument,
  GetAvailableSlotsDocument,
  GetBookingByIdDocument,
  GetBookingsDocument,
  GetBookingsOverviewDocument,
  GetConsumerByEmailAddressDocument,
  GetConsumerByIdDocument,
  GetConsumerDocument,
  GetEntitlementsForProductDocument,
  GetExperienceByIdDocument,
  GetFlightDetailsDocument,
  GetInvitationByIdDocument,
  GetLocationDescriptionDocument,
  GetMeDocument,
  GetOutletDocument,
  GetOutletLocationDetailsGroupsDocument,
  GetOutletsCountDocument,
  GetOutletsDocument,
  GetPartnerBrandByIdDocument,
  GetPartnerBrandsCountDocument,
  GetPartnerBrandsDocument,
  GetPartnerByIdDocument,
  GetPaymentCardsDocument,
  GetPaymentSessionDocument,
  GetPaymentStatusDocument,
  GetProductByCodeDocument,
  GetTokenExCvvConfigDocument,
  GetTranslationsCountDocument,
  GetTranslationsDocument,
  GetUsersForPartnerDocument,
  GetValidInvitationFromTokenDocument,
  InvitationUserType,
  IsInvitationTokenValidDocument,
  IsoCountryCode,
  JourneyLeg,
  LastEditedByType,
  LinkAccountDocument,
  LinkedAccountLifecycleStatus,
  LinkedAccountProvider,
  LinkedAccountStatusUpdatedBy,
  LocaleCode,
  LocationType,
  MakePaymentDocument,
  MembershipPlanStatus,
  MembershipStatus,
  MobileAppDataStatus,
  OperationType,
  Origin,
  OtpRequestStatus,
  OutletCategory,
  OutletDraftWorkflowStage,
  OutletIdType,
  OutletLocationDetailsSection,
  OutletOpenStatus,
  OutletRegion,
  OutletSetDataSourceTypes,
  OutletStatus,
  OutletSubmissionDecision,
  OutletVersionStatus,
  OutletWorkflowStage,
  OutletWorkflowStatus,
  PanStatus,
  PanTypes,
  PartnerBrandStatus,
  PartnerRoleType,
  PartnerUserStatus,
  PartnerUserType,
  PassengerType,
  PayByLinkBin,
  PaymentCardBrand,
  PaymentCustomerStatus,
  PaymentMethod,
  PaymentMethodType,
  PaymentMode,
  PaymentOption,
  PaymentProgramme,
  PaymentProvider,
  PaymentRefundPriority,
  PaymentRefundStatusResult,
  PaymentRefundType,
  PaymentSessionSource,
  PaymentStatusResult,
  PaymentType,
  PrimaryProductAccessType,
  ProductCategory,
  ProductCostType,
  ProductFamily,
  ProductIdType,
  ProductStage,
  ProductStatus,
  ProductType,
  ProductValuationDocument,
  Programme,
  Proposition,
  PublishOutletDocument,
  RecordPartnerUserLoginDocument,
  RefundStatus,
  RefundStatusReasonCode,
  RevertOutletDocument,
  ReviewLookupType,
  ReviewOutletSubmissionDocument,
  SearchAirportsDocument,
  SearchCatalogueDocument,
  SearchExperiencesDocument,
  SearchIsoCountryCode,
  SearchLocaleCode,
  SearchLocationType,
  SearchObjectType,
  SearchOutletCategory,
  SearchOutletRegion,
  SearchPassengerType,
  SearchPrimaryProductAccessType,
  SearchProductCategory,
  SearchProductStatus,
  SearchTranslationMemoryDocument,
  SearchType,
  SlotState,
  SmokingPolicy,
  SortBy,
  SortField,
  SortOrder,
  Status,
  StatusReasonCode,
  StripeUiMode,
  SubmitOutletForApprovalDocument,
  SubmitTokenExTokenDocument,
  Theme,
  Tier,
  TierCyclePeriod,
  TierDurationType,
  TierExpiryAction,
  TimezoneType,
  TransactionInitiator,
  TransactionType,
  TransferMethod,
  TranslationIdType,
  TranslationStatus,
  TripLegType,
  TripPurpose,
  TripSource,
  TripState,
  TripType,
  UpdateCheckoutSessionDocument,
  UpdateConsumerDocument,
  UpdateOutletDocument,
  UserMembershipOrderKey,
  ValuationProgramme,
  VariationType,
  VerifyPaymentWebAppDocument,
  VisitorCategory,
  VisitorType
});
